import { useCallback, useEffect, useLayoutEffect, useRef, useState, useSyncExternalStore } from 'react';
import { TelaCarregamento } from '../components/TelaCarregamento';
import { playPortal } from '../audio/mixer';
import { api } from '../api';
import { useHttpApi } from '../api/mode';
import { ApiError, type HuntOrder, type CasaItens, type CasaItensMove, type CasaPlaca, type FerramentaRegras, type Guild, type Inspecao, type MinhaCasa, type Pack, type PackItem } from '../api/types';
import { carteiraDoPack } from '../components/itemUi';
import { SLOT_ARMA } from '../data/hotbar';
import { armaServeSkill, type DummyTrainSkill } from '../data/armas';
import { aceitaAutoAlvo, ehMagia, MAGIAS } from '../data/magias';
import { GuildGump } from '../components/GuildGump';
import { AmigosGump } from '../components/AmigosGump';
import { EventoGump } from '../components/EventoGump';
import { EventoSelo, eventoEstaRolando } from '../components/EventoSelo';
import { ChefeBarra } from '../components/ChefeBarra';
import { PentaGump } from '../components/PentaGump';
import { AvisoFaixa } from '../components/AvisoFaixa';
import { CantoDireito } from '../components/CantoDireito';
import { DesempenhoGump } from '../components/DesempenhoGump';
import { HuntGump } from '../components/HuntGump';
import { AllianceInviteGump, GuildInviteGump, WarInviteGump } from '../components/GuildInviteGump';
import { GmGump } from '../components/GmGump';
import { GmSkillsGump } from '../components/GmSkillsGump';
import { GumpWindow, type WindowAnchor } from '../components/GumpWindow';
import { SkillBar } from '../components/SkillBar';
import { InventoryGump } from '../components/InventoryGump';
import { BankGump } from '../components/BankGump';
import { LootGump, DRAG_CORPSE } from '../components/LootGump';
import { LeilaoGump } from '../components/LeilaoGump';
import { CoroaVip } from '../components/CoroaVip';
import { LojaGump } from '../components/LojaGump';
import { DueloConfigGump } from '../components/DueloConfigGump';
import { OficinaGump } from '../components/OficinaGump';
import { CompraCidadeGump } from '../components/CompraCidadeGump';
import { VenderGump } from '../components/VenderGump';
import { HouseGump } from '../components/HouseGump';
import { ProfileGump } from '../components/ProfileGump';
import { companheiros, PainelGrupo } from '../components/hud/PainelGrupo';
import { PartyInviteGump } from '../components/PartyInviteGump';
import { PlayerMenu } from '../components/PlayerMenu';
import { DueloHud } from '../components/DueloHud';
import { DueloResultadoAviso } from '../components/DueloResultadoAviso';
import { ResBloqueioAviso } from '../components/ResBloqueioAviso';
import { ResgateCorpo, motivoCurto, nomeDoLugarDoCorpo } from '../components/hud/ResgateCorpo';
import { ResOfertaAviso } from '../components/ResOfertaAviso';
import { DueloConviteGump } from '../components/DueloConviteGump';
import { DueloConviteCard, DueloEnviadoPilula } from '../components/DueloConviteCard';
import { DummyMenu } from '../components/DummyMenu';
import { DummyTrainGump } from '../components/DummyTrainGump';
import { DpsGump } from '../components/DpsGump';
import { PlayerTip } from '../components/PlayerTip';
import { ReportModal } from '../components/ReportModal';
import { InspecaoGump } from '../components/InspecaoGump';
import { GuardaRoupaGump } from '../components/GuardaRoupaGump';
import { SettingsModal } from '../components/SettingsModal';
import { lerRetornoDiscord } from '../components/DiscordCartao';
import { SuporteModal } from '../components/SuporteModal';
import { RankingsModal } from '../components/RankingsModal';
import { aoCorreio } from '../correio/aviso';
import { CorreioGump } from '../components/correio/CorreioGump';
import { IndicarGump } from '../components/indicacoes/IndicarGump';
import { aoAvisoDeSuporte } from '../suporte/aviso';
import { VERSAO_FRONT, type DadosDoJogo } from '../suporte/coleta';
import { TradeGump } from '../components/TradeGump';
import { TradeInviteGump } from '../components/TradeInviteGump';
import { PortalGump } from '../components/PortalGump';
import { TellPanel } from '../components/TellModal';
import { HoraDoMundo } from '../components/HoraDoMundo';
import { existe, t } from '../i18n/idioma';
import { falaDoNpc, nomeDaSkill, nomeDoInimigo, nomeDoItem, papelDoTitulo } from '../i18n/nomes';
import { marcarMundo, pressionada, rotuloTecla, teclaDe } from '../input/atalhos';
import { useAtalho } from '../input/useAtalhos';
import { HintBar } from '../components/HintBar';
import { cargoDePapel, marcaStaff, nomeComMarca, wireFromLabel } from '../look/nickColor';
import { definirDonoPosicoes } from '../components/hud/posicoes';
import { useSession } from '../state/SessionContext';
import { useWorld } from '../world/useWorld';
import type { TreinoAlvo } from '../world/types';
import { mapaDeEvento } from '../world/engine';
import { longeDoNpc, NPC_ALCANCE_PADRAO } from '../world/npcs';
import { carregarCatalogo, registroPorCidade } from '../world/mapa';
import { destinoDaCasa, type ViagemDestino } from '../world/viagens';
import { definirMundoAberto, definirOcupado } from '../sistema/atualizacao';
import {
  alturaAcimaDoPiso, carregarCasas, casaDoPonto, colocacaoGira, definirCasasDoMapa, definirCliqueNaCasa, definirCliqueNaFerramenta,
  definirCliqueNaPlaca, definirFerramentasDaCidade, destacarNaCasa, girarColocacao, iniciarColocacao,
  mudarAlturaColocacao, pararColocacao, type PlacaDaCasa
} from '../world/casas';
import {
  BauGump, CasaBarra, ColocarGump, ColocarMinimizado, FaixaColocacao, GerirGump, MenuDaPeca, PlacaGump, nomeDaCasa, nomeDoBau,
  resumoBonus, vagaDoItem, type PapelDaLista, type PecaDoMenu
} from '../components/casa/CasaUi';
import { alturaDe, BAU_COMUM, girosDe, mobiliaDe } from '../data/mobiliaInfo';
import { definirIrAte } from '../components/FaixaOficio';
import { craftAgora, ouvirCraft, pararCraft } from '../components/craftAndamento';
import { PilulaIdle } from '../components/hud/PilulaIdle';
import { ItemIcon } from '../components/ItemIcon';
import { tempoDesde } from '../components/hud/useTempoCacada';

/** A janela de cada ofício (o menu Ofícios do topo). */
const JANELA_DO_OFICIO: Record<string, 'ferreiro' | 'alfaiate' | 'arqueiro'> = {
  ferraria: 'ferreiro', alfaiataria: 'alfaiate', arcos: 'arqueiro'
};
import { BarraTopo, itemMenu, type ItemMenu, type Janela, type PopId } from '../components/hud/BarraTopo';
import { NavCelular } from '../components/hud/NavCelular';
import { ChatHud } from '../components/hud/ChatHud';
import { GuiaBoasVindas } from '../components/hud/GuiaBoasVindas';
import { PopCidade, PopLojas, PopMais, PopOficios, PopSocial, PopTreinar, pararCacada, teclaDeAcao } from '../components/hud/pops';
import { LARGURA_POP_FADIGA, PopFadiga } from '../components/hud/ResumoFadiga';
import { ViajarGump } from '../components/hud/ViajarGump';
import { PilulaCacada } from '../components/hud/PilulaCacada';
import { ColetaGump } from '../components/hud/ColetaGump';
import { useColeta } from '../components/hud/useColeta';
import { recursoDe } from '../components/hud/coletaRecurso';
import { ancoraAoLado, type PosicoesBotoes } from '../components/hud/BotoesFlutuantes';
import { useAmigos } from '../components/hud/useAmigos';
import { useCacadaAtiva } from '../components/hud/useCacadaAtiva';
import { useChatNaoLidas } from '../components/hud/useChatNaoLidas';
import { useNovidadeLoja } from '../components/hud/useNovidadeLoja';
import { ModoTelaContext, useModoTela } from '../components/hud/useModoTela';
import { lerConfirmarInocente } from '../components/hud/preferencias';
import { ConfirmarAtaque } from '../components/ConfirmarAtaque';

type PanelId = 'mapa' | 'ordens';

/** Um painel por canto: nenhum nasce em cima do outro, em qualquer tela. */
const PANELS: ReadonlyArray<{ id: PanelId; chave: string; anchor: WindowAnchor }> = [
  { id: 'mapa',   chave: 'mundo.mapa',   anchor: { right: 14, top: 58 } },
  { id: 'ordens', chave: 'mundo.ordens', anchor: { right: 14, bottom: 90 } }
];

/** Minimapa nasce em right:14 com 280px; 12px de folga à esquerda dele. */
const TREINO_ANCHOR: WindowAnchor = { right: 306, top: 58 };
const DPS_ANCHOR: WindowAnchor = { left: 370, top: 58 };
const INSPECAO_ANCHOR: WindowAnchor = { left: 370, top: 90 };

function formatarCriminal(segundos: number): string {
  const n = Math.max(0, Math.floor(segundos));
  const m = Math.floor(n / 60);
  const r = n % 60;
  return `${m}:${r.toString().padStart(2, '0')}`;
}

/** Ordens do escopo 1: a interface existe, a simulação chega com o backend. */
const ORDERS = [
  { id: 'minerar',  nome: 'mundo.ordemMinerar',  detalhe: 'mundo.ordemMinerarDetalhe' },
  { id: 'forjar',   nome: 'mundo.ordemForjar',   detalhe: 'mundo.ordemForjarDetalhe' },
  { id: 'cacar',    nome: 'mundo.cacar',         detalhe: 'mundo.ordemCacarDetalhe' },
  { id: 'escrever', nome: 'mundo.ordemEscrever', detalhe: 'mundo.ordemEscreverDetalhe' }
] as const;

type OpenTell = { key: string; label: string };

const tellKey = (name: string) => name.trim().toLowerCase();
/** Abas de conversa com amigos no chat (techspec-hud-v3 §23); a mais antiga sai quando passa disso. */
const MAX_CONVERSAS = 4;

const PACK_LEFT = 14;
const PACK_TOP = 58;
const PACK_WIDTH = 496;
const PACK_H = 440;
/** Folga entre o centro do sprite e a borda direita da mochila. */
const PACK_GAP = 48;
const TRADE_GAP = 8;
const LOOT_W = 560;
const LOOT_H = 420;
/** Folga entre o centro do sprite e a borda direita do caixão. */
const LOOT_GAP = 56;

/** Câmera segue o jogador, mas na borda do mapa o sprite sai do centro. */
function besidePlayerPack(
  canvas: HTMLCanvasElement | null,
  player: { x: number; y: number } | null
): WindowAnchor {
  if (!canvas || !player) return {};
  const px = player.x;
  const py = player.y;
  return {
    left: Math.max(8, Math.round(px - PACK_WIDTH - PACK_GAP)),
    top: Math.max(48, Math.round(py - PACK_H * 0.55))
  };
}

function besidePack(win: HTMLElement | null): WindowAnchor {
  if (win) {
    const box = win.getBoundingClientRect();
    if (box.width > 0) {
      return { left: Math.round(box.right + TRADE_GAP), top: Math.round(box.top) };
    }
  }
  return { left: PACK_LEFT + PACK_WIDTH + TRADE_GAP, top: PACK_TOP };
}

/** Câmera segue o jogador: o sprite fica no centro do canvas. */
function besideYou(canvas: HTMLCanvasElement | null): WindowAnchor {
  if (!canvas) return { left: PACK_LEFT, top: PACK_TOP };
  const box = canvas.getBoundingClientRect();
  const cx = box.left + box.width / 2;
  const cy = box.top + box.height / 2;
  return {
    left: Math.max(8, Math.round(cx - LOOT_W - LOOT_GAP)),
    top: Math.max(48, Math.round(cy - LOOT_H * 0.55))
  };
}

const EVENTO_SELO_ANCHOR: WindowAnchor = { right: 306, top: 58 };
const EVENTO_GUMP_W = 320;

function besideEventoSelo(win: HTMLElement | null): WindowAnchor {
  if (win) {
    const box = win.getBoundingClientRect();
    if (box.width > 0) {
      const cabeAoLado = box.left >= EVENTO_GUMP_W + TRADE_GAP + 8;
      if (cabeAoLado) {
        return {
          right: Math.round(window.innerWidth - box.left + TRADE_GAP),
          top: Math.round(box.top)
        };
      }
      return {
        right: Math.round(window.innerWidth - box.right),
        top: Math.round(box.bottom + TRADE_GAP)
      };
    }
  }
  return { right: EVENTO_SELO_ANCHOR.right! + 200 + TRADE_GAP, top: EVENTO_SELO_ANCHOR.top! };
}

export function WorldScreen() {
  const { character, account, back, marcarTutorialFeito, enterWorld } = useSession();
  /**
   * A entrada no mundo falhou: sai da tela do mundo (fecha a conexão) e entra de novo com o mesmo personagem. O
   * intervalo deixa o React desmontar o mundo antes de montar outro.
   */
  const entrarDeNovo = () => {
    if (!character) return;
    const quem = character;
    back();
    window.setTimeout(() => enterWorld(quem), 80);
  };
  /* As posições guardadas da HUD são deste personagem; vale já no render, antes das janelas se colocarem. */
  definirDonoPosicoes(character?.id ?? '');
  const playerName = character?.name ?? account?.displayName ?? t('mundo.aventureiro');
  const staffCargo = cargoDePapel(account?.role);
  const marca = marcaStaff(staffCargo);
  const nomeMarcado = nomeComMarca(playerName, staffCargo);
  const net = useHttpApi;
  const [menu, setMenu] = useState<{ name: string; x: number; y: number; guildTag: string; cargo: number; notoriety: number; rel: number; dist?: number } | null>(null);
  /**
   * Atacar um inocente sendo inocente (Configurações › Jogabilidade): a pergunta aberta e os alvos já confirmados nesta
   * sessão (a mesma pessoa não pergunta duas vezes).
   */
  const [perguntaAtaque, setPerguntaAtaque] = useState<{ nome: string; id: number; fazer: () => void } | null>(null);
  const inocentesConfirmados = useRef(new Set<number>());
  /** Faz o ataque, ou pergunta antes se for o primeiro golpe de um inocente em outro inocente. Devolve se já fez. */
  const atacarConfirmando = (targetId: number, fazer: () => void): boolean => {
    const alvo = world.getTargetInfo();
    const precisa = lerConfirmarInocente()
      && alvo != null && alvo.id === targetId
      && alvo.kind === 'player' && alvo.notoriety === 0
      && world.getSelfNotoriety() === 0
      && !inocentesConfirmados.current.has(targetId);
    if (!precisa) {
      fazer();
      return true;
    }
    setPerguntaAtaque({ nome: alvo!.nome, id: targetId, fazer });
    return false;
  };
  const atacarConfirmandoRef = useRef(atacarConfirmando);
  atacarConfirmandoRef.current = atacarConfirmando;
  const [naArena, setNaArena] = useState(false);
  const esquecerDueloRef = useRef<() => void>(() => {});
  const [dummyMenu, setDummyMenu] = useState<{ id: number; x: number; y: number } | null>(null);
  const [tip, setTip] = useState<{ name: string; x: number; y: number } | null>(null);
  const [reportName, setReportName] = useState<string | null>(null);
  const [inspecao, setInspecao] = useState<Inspecao | null>(null);
  const [guardaRoupaOpen, setGuardaRoupaOpen] = useState(false);
  const menuOpen = useRef(false);
  const [friendsOpen, setFriendsOpen] = useState(false);
  const [dpsOpen, setDpsOpen] = useState(false);
  const ehStaff = account?.role === 'gm' || account?.role === 'admin';
  const [gmOpen, setGmOpen] = useState(false);
  const [gmOculto, setGmOculto] = useState(false);
  const [gmSkillsAlvo, setGmSkillsAlvo] = useState<{ id: string; name: string } | null>(null);
  const [gmSkillsTick, setGmSkillsTick] = useState(0);
  const gmSkillsDirty = useRef(false);
  // A volta do Discord (?discord=ok|erro): abre as Configurações em Conta com o resultado (techspec-discord-cargos §09).
  const [retornoDiscord] = useState(lerRetornoDiscord);
  const [settingsOpen, setSettingsOpen] = useState(() => retornoDiscord !== null);
  const [suporteOpen, setSuporteOpen] = useState(false);
  const [suportePede, setSuportePede] = useState(0);
  const [rankingsOpen, setRankingsOpen] = useState(false);
  const [venderOpen, setVenderOpen] = useState(false);
  const [correioOpen, setCorreioOpen] = useState(false);
  const [indicarOpen, setIndicarOpen] = useState(false);
  // Indicar amigos no Mais (techspec-indicacoes §04): some quando o console desliga.
  const [indicarAtivo, setIndicarAtivo] = useState(false);
  const [correioAbrir, setCorreioAbrir] = useState<string | null>(null);
  const [correio, setCorreio] = useState({ novas: 0, pendentes: 0, chegou: false });
  const [proximoEvento, setProximoEvento] = useState<{ hora: string; emMs: number; tipo?: string } | null>(null);
  const [packOpen, setPackOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [marketOpen, setMarketOpen] = useState(false);
  const [lojaOpen, setLojaOpen] = useState(false);
  const [lojaAba, setLojaAba] = useState<string | null>(null);
  const [lojaOuro, setLojaOuro] = useState<number | null>(null);
  /* Uma janela por ofício (Renato, 04/11/2026): Ferreiro, Arqueiro e Alfaiate, cada um com a sua. */
  const [ferreiroOpen, setFerreiroOpen] = useState(false);
  const [arqueiroOpen, setArqueiroOpen] = useState(false);
  /* O craft em andamento minimiza a janela do ofício numa pílula, como a caçada e a coleta. */
  const craft = useSyncExternalStore(ouvirCraft, craftAgora);
  const [craftMin, setCraftMin] = useState(false);
  const craftAtivo = !!craft;
  useEffect(() => { setCraftMin(craftAtivo); }, [craftAtivo]);
  const [agoraCraft, setAgoraCraft] = useState(() => Date.now());
  useEffect(() => {
    if (!craftAtivo) return;
    const id = window.setInterval(() => setAgoraCraft(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [craftAtivo]);
  const [alfaiateOpen, setAlfaiateOpen] = useState(false);
  /** A janela do ofício que está craftando está aberta? Fechada no meio do craft, a pílula volta. */
  const janelaDoCraftAberta = craft?.oficio === 'ferraria' ? ferreiroOpen : craft?.oficio === 'arcos' ? arqueiroOpen
    : craft?.oficio === 'alfaiataria' ? alfaiateOpen : false;
  const [guildOpen, setGuildOpen] = useState(false);
  const [huntOpen, setHuntOpen] = useState(false);
  const [eventoOpen, setEventoOpen] = useState(false);
  const eventoSeloRef = useRef<HTMLButtonElement>(null);
  const mundoRef = useRef<HTMLElement>(null);
  const modo = useModoTela(mundoRef);
  const compacto = modo === 'cel' || modo === 'deitado';
  const [eventoSpot, setEventoSpot] = useState<WindowAnchor>(() => besideEventoSelo(null));
  const [house, setHouse] = useState<Guild | null>(null);
  const [houseTick, setHouseTick] = useState(0);
  const [packTick, setPackTick] = useState(0);
  const [wallet, setWallet] = useState({ gold: 0, silver: 0 });
  const [online, setOnline] = useState(1);
  const [dead, setDead] = useState(!!character?.dead);
  useEffect(() => { setDead(!!character?.dead); }, [character?.id, character?.dead]);
  const [tutorial, setTutorial] = useState(!!character?.tutorial);
  useEffect(() => { setTutorial(!!character?.tutorial); }, [character?.id, character?.tutorial]);
  const concluirTutorial = useCallback(() => {
    setTutorial(false);
    marcarTutorialFeito();
    const id = character?.id;
    const shardId = character?.shardId;
    if (id && shardId) void api.concluirTutorial(shardId, id);
  }, [character?.id, character?.shardId, marcarTutorialFeito]);
  /**
   * O guia de boas-vindas (GuiaBoasVindas, techspec-boas-vindas): abre sozinho enquanto o tutorial do personagem está
   * pendente, e de novo em Mais › Guia do jogo. Fechar (pular, Esc ou o fim) conclui o tutorial pendente.
   */
  const [guiaRevendo, setGuiaRevendo] = useState(false);
  const guiaAberto = tutorial || guiaRevendo;
  const fecharGuia = useCallback(() => {
    setGuiaRevendo(false);
    if (tutorial) concluirTutorial();
  }, [tutorial, concluirTutorial]);
  useEffect(() => {
    marcarMundo(true);
    return () => marcarMundo(false);
  }, []);
  const packWrapRef = useRef<HTMLDivElement>(null);
  const tradeWrapRef = useRef<HTMLDivElement>(null);
  const [dueloAlvo, setDueloAlvo] = useState<string | null>(null);
  const [packSpot, setPackSpot] = useState<WindowAnchor | null>(null);
  const [tradeSpot, setTradeSpot] = useState<WindowAnchor>(() => ({
    left: PACK_LEFT + PACK_WIDTH + TRADE_GAP,
    top: PACK_TOP
  }));
  const [friendNames, setFriendNames] = useState<ReadonlySet<string>>(() => new Set());
  const [pop, setPop] = useState<PopId | null>(null);
  /**
   * Teleporte e Recursos (os botões flutuantes) são janelas independentes (Renato, 02/11): abrir um não fecha o outro,
   * nem a mochila, os amigos ou um menu da barra. Cada um fecha no próprio botão ou no X.
   */
  const [fabAberto, setFabAberto] = useState<{ readonly viajar: boolean; readonly recursos: boolean }>({ viajar: false, recursos: false });
  const alternarFab = (id: 'viajar' | 'recursos') => { setChatAberto(false); setFabAberto(f => ({ ...f, [id]: !f[id] })); };
  const fecharFab = (id: 'viajar' | 'recursos') => setFabAberto(f => (f[id] ? { ...f, [id]: false } : f));
  // Um menu da barra que pede o Teleportar ou os Recursos abre o botão flutuante, não um pop.
  useEffect(() => {
    if (pop !== 'viajar' && pop !== 'recursos') return;
    const id = pop;
    setFabAberto(f => ({ ...f, [id]: true }));
    setPop(null);
  }, [pop]);
  const [chatAberto, setChatAberto] = useState(false);
  /** Enter no mundo: foca a fala local. É um instante (Date.now) para o pedido valer uma vez. */
  const [focoFala, setFocoFala] = useState(0);
  const cacandoRef = useRef(false);
  const [chatMin, setChatMin] = useState(() => {
    try { return localStorage.getItem('uoidle.chat.min') === '1'; } catch { return false; }
  });
  const [minimapaCompacto, setMinimapaCompacto] = useState(false);
  const [viagemMenu, setViagemMenu] = useState<ViagemDestino | null>(null);
  /** Teleportar → Minha casa (techspec-casas §02.7): a linha só aparece para quem tem casa. */
  const [destinoCasa, setDestinoCasa] = useState<ViagemDestino | null>(null);
  /** Onde os botões flutuantes estão (Viajar abre ao lado do seu) e a caçada escolhida em Viajar. */
  const [posFab, setPosFab] = useState<PosicoesBotoes>({});
  /** §23: conversas com amigos abertas como abas do chat; `conversaChat` é a aba da frente (null = um canal). */
  const [conversasChat, setConversasChat] = useState<readonly OpenTell[]>([]);
  const [conversaChat, setConversaChat] = useState<string | null>(null);
  const conversaNovaRef = useRef<(nome: string) => void>(() => {});
  const treinoAlvoRef = useRef<(alvo: TreinoAlvo) => void>(() => {});
  const [shardNome, setShardNome] = useState('');
  const [mapaId, setMapaId] = useState<string | undefined>(undefined);
  const [natal, setNatal] = useState('');
  const mochilaPeloBanco = useRef(false);
  const ultimasJanelas = useRef<Janela[]>([]);
  const atenderRef = useRef<(
    id: string, nome: string, titulo: string, x: number, y: number,
    temLoja: boolean, temCorretor: boolean, temBanco: boolean, remoteId: number, alcance: number,
    viaMenu: boolean
  ) => void>(() => {});
  const fecharMapaRef = useRef<() => void>(() => {});
  const alternarRef = useRef<(j: Janela) => void>(() => {});
  const menuHudRef = useRef<(m: ItemMenu) => void>(() => {});
  /** Abrir uma janela de fora da ordem de declaração (o clique na ferramenta da cidade). */
  const abrirJanelaRef = useRef<(j: Janela) => void>(() => {});
  const falarRef = useRef<() => void>(() => {});
  const recarregarAmigosRef = useRef<() => void>(() => {});
  const aoAbrirTellRef = useRef<() => void>(() => {});
  const [openTells, setOpenTells] = useState<readonly OpenTell[]>([]);
  const openTellRef = useRef<(name: string) => void>(() => {});
  const tileRef = useRef<{ x: number; y: number } | null>(null);
  const [shop, setShop] = useState<{
    npcId: string; nome: string; x: number; y: number; remoteId: number; papel: string; alcance: number; viaMenu?: boolean;
  } | null>(null);
  const shopRef = useRef(shop);
  shopRef.current = shop;
  const [corretor, setCorretor] = useState<{
    npcId: string; nome: string; x: number; y: number; remoteId: number; papel: string; fala: string; alcance: number; viaMenu?: boolean;
  } | null>(null);
  const corretorRef = useRef(corretor);
  corretorRef.current = corretor;
  const [corretorSpot, setCorretorSpot] = useState<WindowAnchor>(() => besidePack(null));
  const [banco, setBanco] = useState<{
    npcId: string; nome: string; x: number; y: number; remoteId: number; papel: string; alcance: number; viaMenu?: boolean;
  } | null>(null);
  const bancoRef = useRef(banco);
  bancoRef.current = banco;
  const [bancoSpot, setBancoSpot] = useState<WindowAnchor>(() => besidePack(null));
  const npcFalaRef = useRef<(
    remoteId: number, nome: string, papel: string,
    evento: string, total?: number
  ) => void>(() => {});
  const falarNpcRef = useRef<(remoteId: number, texto: string) => void>(() => {});
  const sayKeyRef = useRef<(chave: string, args: Record<string, string | number>) => void>(() => {});
  /** A janela Comprar aberta pelo menu Lojas (compras da cidade). Pelo balcão do NPC, é o `shop`. */
  const [compraOpen, setCompraOpen] = useState(false);

  const world = useWorld({
    playerName,
    staffCargo,
    homeCity: character?.homeCity ?? 'minoc',
    characterId: character?.id,
    skin: character?.skin,
    skinHue: character?.skinHue,
    dead: character?.dead,
    notoriety: wireFromLabel(character?.notoriety),
    net,
    onDead(next) {
      setDead(next);
      setPackTick(n => n + 1);
    },
    onPlayerMenu(name, x, y, guildTag = '', cargo = 0, info) {
      menuOpen.current = true;
      setTip(null);
      setDummyMenu(null);
      setMenu({ name, x, y, guildTag, cargo, notoriety: info?.notoriety ?? 0, rel: info?.rel ?? 0, dist: info?.dist });
    },
    onMapa(id) {
      setMapaId(id);
      fecharMapaRef.current();
      const arena = id === 'arena-duelo-ice-age';
      setNaArena(arena);
      if (arena) setPackOpen(false);
      if (mapaDeEvento(id)) {
        menuOpen.current = false;
        setMenu(null);
        setDummyMenu(null);
        setTip(null);
      }
      if (!arena) esquecerDueloRef.current();
    },
    onDummyMenu(id, x, y) {
      menuOpen.current = true;
      setTip(null);
      setMenu(null);
      setDummyMenu({ id, x, y });
    },
    onPlayerHover(hit) {
      if (menuOpen.current) return;
      setTip(hit);
    },
    onNpcClick(id, nome, titulo, x, y, temLoja, temCorretor, temBanco, remoteId, alcance) {
      atenderRef.current(id, nome, titulo, x, y, temLoja, temCorretor, temBanco, remoteId, alcance, false);
    },
    onBankOpen(npcId, nome, x, y, remoteId, alcance) {
      // "banco" dito na cidade; na caçada o banco fica travado, como no menu.
      if (cacandoRef.current) {
        world.say(t('hud.trava.aviso', { menu: t('banco.titulo'), cidade: natal }), 'warn');
        return;
      }
      const papel = 'banqueiro';
      const raio = alcance || NPC_ALCANCE_PADRAO;
      const prev = bancoRef.current;
      if (prev && prev.npcId !== npcId)
        npcFalaRef.current(prev.remoteId, prev.nome, prev.papel, 'despedida');
      const loja = shopRef.current;
      if (loja)
        npcFalaRef.current(loja.remoteId, loja.nome, loja.papel, 'despedida');
      const outro = corretorRef.current;
      if (outro)
        npcFalaRef.current(outro.remoteId, outro.nome, outro.papel, 'despedida');
      setShop(null);
      setCorretor(null);
      // A palavra abre em qualquer ponto da cidade. Sem viaMenu o efeito de
      // distância fecha no mesmo quadro, porque o jogador não está no alcance.
      setBanco({ npcId, nome, x, y, remoteId, papel, alcance: raio, viaMenu: true });
      npcFalaRef.current(remoteId, nome, papel, 'saudacao');
    },
    onTreinoAlvo(alvo) { treinoAlvoRef.current(alvo); },
    onIncomingTell(name) {
      // Amigo: a conversa ganha (ou mantém) a aba no chat, sem tirar o jogador do que está vendo (§23).
      if (friendNames.has(name.trim().toLowerCase())) {
        conversaNovaRef.current(name);
        return;
      }
      openTellRef.current(name);
    }
  });
  /**
   * O guia só aparece depois da tela de carregamento: o mundo pronto e o fade da TelaCarregamento terminado. Uma vez
   * liberado, fica liberado (uma viagem com o guia aberto não o esconde).
   */
  const [guiaLiberado, setGuiaLiberado] = useState(false);
  const mundoPronto = world.carga.etapa === 'pronto' && !world.failure;
  useEffect(() => {
    if (!mundoPronto || guiaLiberado) return;
    const id = window.setTimeout(() => setGuiaLiberado(true), 700);
    return () => window.clearTimeout(id);
  }, [mundoPronto, guiaLiberado]);
  npcFalaRef.current = (remoteId, nome, papel, evento, total) => {
    const fala = falaDoNpc(papel, evento);
    if (!fala) return;
    world.falarNpc(remoteId, fala);
    if (evento === 'compra' && total != null)
      world.sayKey('npc.diario.compra', { nome, total, fala }, 'plain');
    else
      world.say(`${nome}: ${fala}`, 'plain');
  };
  falarNpcRef.current = (remoteId, texto) => world.falarNpc(remoteId, texto);
  sayKeyRef.current = (chave, args) => world.sayKey(chave, args, 'plain');
  tileRef.current = world.status
    ? { x: world.status.tileX, y: world.status.tileY }
    : null;
  useEffect(() => {
    if (world.lootPulse > 0) setPackTick(n => n + 1);
  }, [world.lootPulse]);
  useEffect(() => {
    world.setOculto(gmOculto);
  }, [gmOculto]);
  // A cada welcome o servidor diz se a staff entrou oculta (troca de mapa, de canal, reconexão): o cinza e o selo
  // do topo seguem o servidor, não o que o cliente lembrava.
  useEffect(() => {
    if (world.ocultoServidor) setGmOculto(world.ocultoServidor.ligado);
  }, [world.ocultoServidor]);
  useEffect(() => {
    if (!eventoEstaRolando(world.evento)) setEventoOpen(false);
  }, [world.evento]);
  /** A barra do chefe abre Mais › Eventos já no detalhe dele (techspec-chefe-mundo §07). */
  const [eventoTipo, setEventoTipo] = useState<string | null>(null);
  const toggleEvento = useCallback(() => {
    setEventoSpot(besideEventoSelo(eventoSeloRef.current));
    setEventoTipo(null);
    setEventoOpen(v => !v);
  }, []);
  const abrirChefe = useCallback(() => {
    setEventoSpot(besideEventoSelo(eventoSeloRef.current));
    setEventoTipo('chefe-mundo');
    setEventoOpen(true);
  }, []);
  useEffect(() => {
    let live = true;
    let tries = 0;
    let timer = 0;
    const load = () => {
      api.getPack()
        .then(pack => {
          if (!live) return;
          setWallet(carteiraDoPack(pack));
          /* HUD V3: o botão da Loja mostra o ouro do cofre desde a entrada */
          if (pack.ouroBanco != null) setLojaOuro(pack.ouroBanco);
        })
        .catch(() => {
          if (!live) return;
          tries += 1;
          if (tries < 16) timer = window.setTimeout(load, 400);
        });
    };
    load();
    return () => {
      live = false;
      window.clearTimeout(timer);
    };
  }, [packTick, character?.id, world.ready]);
  useEffect(() => {
    const shardId = character?.shardId;
    if (!shardId) return;
    let live = true;
    const load = () => {
      void api.listShards()
        .then(list => {
          if (!live) return;
          const hit = list.find(s => s.id === shardId);
          setOnline(hit?.online ?? 1);
          setShardNome(hit?.name ?? '');
        })
        .catch(() => {});
    };
    load();
    const id = window.setInterval(load, 10_000);
    window.addEventListener('focus', load);
    return () => {
      live = false;
      window.clearInterval(id);
      window.removeEventListener('focus', load);
    };
  }, [character?.shardId]);
  const [targetMobId, setTargetMobId] = useState<number | null>(null);
  useEffect(() => {
    if (!gmOpen) {
      setTargetMobId(null);
      return;
    }
    const poll = () => {
      setTargetMobId(world.getTargetKind() === 'monster' ? world.getTargetId() : null);
    };
    poll();
    const t = window.setInterval(poll, 250);
    return () => window.clearInterval(t);
  }, [gmOpen]);

  const [open, setOpen] = useState<ReadonlySet<PanelId>>(
    () => new Set<PanelId>(['mapa'])
  );
  const inventoryOpen = packOpen;

  const toggle = useCallback((id: PanelId) => {
    setOpen(current => {
      const next = new Set(current);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  }, []);

  const close = useCallback((id: PanelId) => {
    setOpen(current => {
      const next = new Set(current);
      next.delete(id);
      return next;
    });
  }, []);

  const anchorOf = (id: PanelId) => PANELS.find(p => p.id === id)!.anchor;

  useAtalho('perfil', () => alternarRef.current('perfil'));

  /** Marca um companheiro como alvo (placa, Alt+1…3). Fora da sala (outro mapa, offline) não há o que marcar. */
  const marcarMembro = (nome: string) => {
    if (!world.marcarJogador(nome)) world.say(t('grupo.foraDaSala', { nome }), 'note');
  };
  const marcarMembroN = (i: number) => {
    const m = world.party ? companheiros(world.party, playerName)[i] : undefined;
    if (m) marcarMembro(m.name);
  };
  useAtalho('alvoGrupo1', () => marcarMembroN(0));
  useAtalho('alvoGrupo2', () => marcarMembroN(1));
  useAtalho('alvoGrupo3', () => marcarMembroN(2));
  useAtalho('mapa', () => {
    if (compacto) { setMinimapaCompacto(v => !v); setPop(null); }
    else toggle('mapa');
  });
  useAtalho('mochila', () => alternarRef.current('mochila'));
  useAtalho('mercado', () => alternarRef.current('mercado'));
  useAtalho('guilda', () => alternarRef.current('guilda'));
  useAtalho('amigos', () => alternarRef.current('amigos'));
  useAtalho('gm', () => alternarRef.current('gm'));
  useAtalho('config', () => alternarRef.current('config'));
  useAtalho('cacar', () => alternarRef.current('cacar'));
  const [desempenhoOpen, setDesempenhoOpen] = useState(false);
  useAtalho('desempenho', () => alternarRef.current('desempenho'));
  useAtalho('viajar', () => alternarFab('viajar'));
  useAtalho('lojas', () => { const m = itemMenu('lojas'); if (m) menuHudRef.current(m); });
  useAtalho('banco', () => { const m = itemMenu('banco'); if (m) menuHudRef.current(m); });
  useAtalho('falar', () => falarRef.current());
  useAtalho('atacar', () => {
    if (!world.net) {
      world.say(t('mundo.combateSoAoVivo'), 'note');
      return;
    }
    if (world.war) {
      world.attack(0);
      return;
    }
    const target = world.getTargetId();
    if (target == null) {
      world.say(t('mundo.selecioneAlvo'), 'note');
      return;
    }
    atacarConfirmandoRef.current(target, () => world.attack(target));
  });
  // Faz a magia em curso falhar de propósito (sem gastar mana). Sem magia no ar, o servidor ignora.
  useAtalho('cancelarMagia', () => {
    if (world.net) world.cancelarMagia();
  });

  const dismissMenu = useCallback(() => {
    menuOpen.current = false;
    setMenu(null);
    setDummyMenu(null);
  }, []);

  /** Arma da skill na mão (equipa da mochila se precisar). Magia não precisa. */
  const prepararArma = useCallback(async (skill: DummyTrainSkill): Promise<boolean> => {
    if (skill === 'magery') return true;
    let pack: Pack;
    try {
      pack = await api.getPack();
    } catch {
      world.sayKey('manequim.semArmaBolsa', { skill }, 'warn');
      return false;
    }
    const naMao = pack.items.find(i => i.equippedSlot === 'mainHand');
    if (naMao && armaServeSkill(naMao.defId, skill)) return true;
    const naBolsa = pack.items.find(i => !i.equippedSlot && armaServeSkill(i.defId, skill));
    if (!naBolsa) {
      world.sayKey('manequim.semArmaBolsa', { skill }, 'warn');
      return false;
    }
    try {
      await api.equipItem(naBolsa.id);
      setPackTick(n => n + 1);
      return true;
    } catch {
      world.sayKey('manequim.semArmaBolsa', { skill }, 'warn');
      return false;
    }
  }, [world]);

  const pickDummySkill = useCallback(async (dummyId: number, skill: DummyTrainSkill) => {
    dismissMenu();
    if (!world.net) {
      world.say(t('mundo.combateSoAoVivo'), 'note');
      return;
    }
    if (!await prepararArma(skill)) return;
    world.approachDummy(
      dummyId,
      skill === 'magery' ? (MAGIAS['magic-arrow'].alcance ?? 10) : 0,
      () => world.trainDummy(dummyId, skill)
    );
  }, [dismissMenu, world, prepararArma]);

  /* Treino automático (docs/techspec-treino-automatico.md): o servidor reservou o manequim (e, se precisou, levou
     o jogador a Minoc por Recall). Anda até ele, mesmo fora da visão, e começa. */
  treinoAlvoRef.current = alvo => {
    const skill = alvo.skill as DummyTrainSkill;
    world.sayKey('manequim.indo', undefined, 'note');
    world.approachDummy(
      alvo.dummyId,
      skill === 'magery' ? (MAGIAS['magic-arrow'].alcance ?? 10) : alvo.alcance,
      () => world.trainDummy(alvo.dummyId, skill),
      { x: alvo.x, y: alvo.y }
    );
  };

  const openTell = useCallback((name: string) => {
    aoAbrirTellRef.current();
    const key = tellKey(name);
    world.openTell(name);
    setOpenTells(cur => {
      const rest = cur.filter(t => t.key !== key);
      const next = [...rest, { key, label: name }];
      if (next.length <= 3) return next;
      const dropped = next[0];
      world.markTellRead(dropped.label);
      return next.slice(1);
    });
    dismissMenu();
  }, [world, dismissMenu]);
  openTellRef.current = openTell;

  const apostaAberta = world.deal?.tipo === 'aposta';
  useLayoutEffect(() => {
    if (!world.deal?.id || naArena) return;
    if (!packOpen) {
      setPackOpen(true);
      return;
    }
    if (world.deal.tipo === 'aposta') {
      const inv = packWrapRef.current?.querySelector<HTMLElement>('.win--inventory') ?? null;
      const trade = tradeWrapRef.current?.querySelector<HTMLElement>('.win--trade') ?? null;
      if (!inv || !trade) return;
      const iw = inv.offsetWidth;
      const tw = trade.offsetWidth;
      if (iw < 40 || tw < 40) return;
      const gap = 12;
      const left = Math.max(8, Math.round((window.innerWidth - iw - gap - tw) / 2));
      const altura = Math.max(inv.offsetHeight, trade.offsetHeight);
      const topo = 78;
      const top = altura + topo + 16 <= window.innerHeight
        ? topo
        : Math.max(48, window.innerHeight - altura - 16);
      const tradeLeft = left + iw + gap;
      setPackSpot(prev => prev?.left === left && prev.top === top ? prev : { left, top });
      setTradeSpot(prev => prev.left === tradeLeft && prev.top === top ? prev : { left: tradeLeft, top });
      return;
    }
    const win = packWrapRef.current?.querySelector<HTMLElement>('.win--inventory') ?? null;
    setTradeSpot(besidePack(win));
  }, [world.deal?.id, world.deal?.tipo, packOpen, naArena]);

  useLayoutEffect(() => {
    if (!corretor) return;
    const win = packWrapRef.current?.querySelector<HTMLElement>('.win--inventory') ?? null;
    setCorretorSpot(besidePack(win));
  }, [corretor, packOpen]);

  useLayoutEffect(() => {
    if (!banco) return;
    if (!packOpen) {
      mochilaPeloBanco.current = true;
      setPackOpen(true);
      return;
    }
    const win = packWrapRef.current?.querySelector<HTMLElement>('.win--inventory') ?? null;
    setBancoSpot(besidePack(win));
  }, [banco, packOpen]);

  const fecharLoja = (motivo: 'close' | 'longe' | 'disconnect' | 'mapa') => {
    const cur = shopRef.current;
    if (!cur) return;
    if (motivo !== 'disconnect' && motivo !== 'mapa')
      npcFalaRef.current(cur.remoteId, cur.nome, cur.papel, 'despedida');
    setShop(null);
  };

  useEffect(() => {
    if (!world.ready) fecharLoja('disconnect');
  }, [world.ready]);

  useEffect(() => {
    if (!shop || shop.viaMenu || !world.status) return;
    if (longeDoNpc(world.status.tileX, world.status.tileY, shop.x, shop.y, shop.alcance))
      fecharLoja('longe');
  }, [shop, world.status]);

  /* As casas erguidas no mapa (techspec-casas §03): ao entrar, a cada 2 min e depois de comprar. */
  const [casasVersao, setCasasVersao] = useState(0);
  /* A interface da casa no mundo (techspec-casas §03.12): barra no alto, Colocar, Gerenciar, baú, menu de clique. */
  const [casaJanela, setCasaJanela] = useState<'colocar' | 'gerir' | null>(null);
  const [casaItens, setCasaItens] = useState<CasaItens | null>(null);
  const [casaMochila, setCasaMochila] = useState<readonly PackItem[]>([]);
  const [bauAberto, setBauAberto] = useState<string | null>(null);
  const [casaMenu, setCasaMenu] = useState<{ x: number; y: number; tipo: 'bau' | 'preso'; px: number; py: number; pz: number } | null>(null);
  /** A peça sendo posta ou movida (techspec-casa-interface-e-baus §04): o item, o nome e se é mover. */
  const [colocando, setColocando] = useState<{ nome: string; defId: string; movendo: boolean; continua: boolean } | null>(null);
  /** "Continuar colocando" (§03): Shift + clique fixa e segue com a mesma peça. */
  const [continuarColocando, setContinuarColocando] = useState(true);
  /** A placa clicada (§09): o rótulo sobre ela por 6 s e a janela; `dados` chega do servidor. */
  const [placa, setPlaca] = useState<{ p: PlacaDaCasa; x: number; y: number; ate: number; dados: CasaPlaca | null } | null>(null);
  /** Os números das ferramentas (§03.3). */
  const [casaRegras, setCasaRegras] = useState<readonly FerramentaRegras[]>([]);
  const [casaOcupada, setCasaOcupada] = useState(false);
  /** A lista de acesso, para o dono (aba Acesso de Gerenciar casa). */
  const [minhaAcesso, setMinhaAcesso] = useState<MinhaCasa | null>(null);
  const mapaDasCasasAgora = world.sala.mapaId || mapaId;
  /* As ferramentas de ofício da cidade (techspec-marceneiro-e-oficios-em-casa §05.2): desenha, e o clique abre o ofício. */
  useEffect(() => {
    if (!mapaDasCasasAgora) return;
    let vivo = true;
    // Postas no Editor de mapa: uma versão publicada aparece na próxima leitura (a cada 2 min, como as casas).
    const ler = () => void api.ferramentasDaCidade(mapaDasCasasAgora)
      .then(lista => { if (vivo) definirFerramentasDaCidade(mapaDasCasasAgora, lista); })
      .catch(() => { if (vivo) definirFerramentasDaCidade(mapaDasCasasAgora, []); });
    ler();
    const relogio = window.setInterval(ler, 120_000);
    definirCliqueNaFerramenta(f => {
      const janela = JANELA_DO_OFICIO[f.oficio];
      if (!janela) return false;
      abrirJanelaRef.current(janela);
      return true;
    });
    return () => { vivo = false; window.clearInterval(relogio); definirCliqueNaFerramenta(null); };
  }, [mapaDasCasasAgora]);
  /* Ir até a ferramenta e craftar (Renato, 03/11/2026): as oficinas pedem, o motor anda. 20 s sem chegar = desiste. */
  useEffect(() => {
    definirIrAte((x, y, raio) => new Promise<boolean>(resolver => {
      let feito = false;
      const fim = (ok: boolean) => { if (!feito) { feito = true; window.clearTimeout(t); resolver(ok); } };
      const t = window.setTimeout(() => fim(false), 20_000);
      world.sayKey('oficio.indo', undefined, 'note');
      if (!world.approachDummy(0, raio, () => fim(true), { x, y })) fim(false);
    }));
    return () => definirIrAte(null);
  }, [world]);
  useEffect(() => {
    if (!mapaDasCasasAgora) return;
    let vivo = true;
    const buscar = () => {
      void api.casasErguidas(mapaDasCasasAgora)
        .then(lista => { if (vivo) void definirCasasDoMapa(mapaDasCasasAgora, lista); })
        .catch(() => {});
      // A minha casa: o Teleportar e a barra da casa (só no mapa dela).
      void api.minhaCasa()
        .then(c => {
          if (!vivo) return;
          setDestinoCasa(c ? destinoDaCasa(c) : null);
        })
        .catch(() => {});
    };
    buscar();
    const t = window.setInterval(buscar, 120_000);
    return () => { vivo = false; window.clearInterval(t); };
  }, [mapaDasCasasAgora, casasVersao]);

  // O catálogo de multis e o atlas já ao entrar no jogo: chegando no vilarejo, as casas não esperam o download.
  useEffect(() => { void carregarCasas(); }, []);

  // Versão nova da interface (techspec-atualizacao-do-cliente): no mundo, a recarga espera o fim do combate e do duelo.
  const dueloAgora = useRef(false);
  dueloAgora.current = !!world.duelo;
  useEffect(() => {
    definirMundoAberto(world.ready);
    definirOcupado(() => dueloAgora.current || document.documentElement.hasAttribute('data-combate'));
    return () => { definirMundoAberto(false); definirOcupado(null); };
  }, [world.ready]);

  // Uma casa deste mapa mudou ("cm", techspec-casas §03.16): relê agora. Várias mudanças juntas viram uma leitura só.
  useEffect(() => {
    const p = world.casasPulse;
    if (!p || p.mapa !== mapaDasCasasAgora) return;
    const t = window.setTimeout(() => setCasasVersao(v => v + 1), 250);
    return () => window.clearTimeout(t);
  }, [world.casasPulse]); // eslint-disable-line react-hooks/exhaustive-deps

  // A casa em que o jogador está agora e o papel dele nela (techspec-casas §03.13). A interface vale em qualquer casa
  // em que ele tem papel; quem mexe (barra, colocar, soltar) é dono e co-dono; o baú abre conforme o "quem abre".
  const casaAqui = mapaDasCasasAgora && world.status ? casaDoPonto(mapaDasCasasAgora, world.status.tileX, world.status.tileY) : null;
  const papelAqui = casaAqui?.papel ?? 'visitante';
  const casaAquiId = casaAqui && ['dono', 'codono', 'amigo', 'convidado'].includes(papelAqui) ? casaAqui.id : null;
  const hid = casaAquiId ?? '';
  const podeMexer = papelAqui === 'dono' || papelAqui === 'codono';
  const naMinhaCasa = !!casaAquiId;
  const recarregarCasa = async () => {
    if (!casaAquiId) return;
    try {
      const [c, p] = await Promise.all([api.casaItens(casaAquiId), api.getPack()]);
      setCasaItens(c);
      setCasaMochila(p.items);
    } catch {
      /* fora da casa ou sem modelo: a barra some sozinha */
    }
  };
  useEffect(() => {
    if (casaAquiId) { void recarregarCasa(); return; }
    setCasaItens(null);
    setCasaJanela(null);
    setBauAberto(null);
    setCasaMenu(null);
    pararColocacao(false);
    setColocando(null);
  }, [casaAquiId]);
  useEffect(() => {
    if (!casaAquiId) return;
    let vivo = true;
    api.oficiosRegras().then(r => { if (vivo) setCasaRegras(r.ferramentas); }).catch(() => {});
    return () => { vivo = false; };
  }, [casaAquiId]);
  useEffect(() => () => pararColocacao(false), []);

  const agirCasa = async (fn: () => Promise<CasaItensMove>, mudaMapa = true): Promise<CasaItensMove | null> => {
    if (casaOcupada) return null;
    setCasaOcupada(true);
    try {
      const r = await fn();
      setCasaItens(r.casa);
      setCasaMochila(r.pack.items);
      setWallet(carteiraDoPack(r.pack));
      setPackTick(n => n + 1);
      if (mudaMapa) setCasasVersao(v => v + 1);
      return r;
    } catch (err) {
      world.say(err instanceof ApiError && err.message ? err.message : t('comum.recusouPedido'), 'warn');
      return null;
    } finally {
      setCasaOcupada(false);
    }
  };

  /**
   * Pôr o Baú comum grátis, um item da mochila (móvel, baú comprado, ferramenta) ou mover uma peça já posta, com o
   * cursor (techspec-casa-interface-e-baus §04). Shift + clique fixa e segue com a mesma peça, se ainda houver.
   */
  type AlvoDaColocacao =
    | { bau: true }
    | { bau: false; item: PackItem }
    | { mover: { tipo: 'bau' | 'preso'; id: string; defId: string; nome: string; x: number; y: number; z: number; giro: number } };
  const comecarColocacao = (alvo: AlvoDaColocacao, giroInicial?: number) => {
    if (!casaAquiId || !podeMexer) return;
    setCasaMenu(null);
    const mover = 'mover' in alvo ? alvo.mover : null;
    const gratis = 'bau' in alvo && alvo.bau;
    const item = 'item' in alvo ? alvo.item : null;
    const defId = gratis ? BAU_COMUM : mover?.defId ?? item!.defId;
    const nome = mover ? nomeDoItem(mover.defId, mover.nome) : nomeDoItem(defId, item?.name);
    const continua = !mover && (gratis
      ? (casaItens?.baus.length ?? 0) + 1 < (casaItens?.maxBaus ?? 0)
      : casaMochila.filter(i => i.defId === defId && !i.equippedSlot && i.id !== item?.id).length > 0 || (item?.qty ?? 0) > 1);
    setColocando({ nome, defId, movendo: !!mover, continua });
    iniciarColocacao({
      casaId: casaAquiId,
      tipo: gratis || mover?.tipo === 'bau' ? 'bau' : 'item',
      defId,
      movendo: mover && mapaDasCasasAgora
        ? { x: mover.x, y: mover.y, z: mover.z, giro: mover.giro, dz: alturaAcimaDoPiso(mapaDasCasasAgora, mover.x, mover.y, mover.z) }
        : undefined,
      giro: giroInicial,
      onPor: (p, shift) => {
        setColocando(null);
        void (async () => {
          const r = await agirCasa(() => (gratis
            ? api.porBauNaCasa(hid, { x: p.x, y: p.y, z: p.z, giro: p.giro })
            : mover?.tipo === 'bau'
              ? api.moverBauDaCasa(hid, mover.id, { x: p.x, y: p.y, z: p.z, giro: p.giro })
              : mover
                ? api.moverNaCasa(hid, mover.id, { x: p.x, y: p.y, z: p.z, giro: p.giro })
                : api.prenderNaCasa(hid, { itemId: item!.id, x: p.x, y: p.y, z: p.z, giro: p.giro })));
          if (!r || !shift || !continuarColocando || mover) return;
          if (gratis) { if (r.casa.baus.length < r.casa.maxBaus) comecarColocacao({ bau: true }, p.giro); return; }
          const prox = r.pack.items.find(i => i.defId === defId && !i.equippedSlot);
          if (prox) comecarColocacao({ bau: false, item: prox }, p.giro);
        })();
      },
      onCancelar: () => setColocando(null),
      onAviso: msg => world.say(msg, 'warn')
    });
  };

  // Clique no baú ou no item preso da minha casa: o menu (techspec-casas §03.12).
  const casaItensRef = useRef<CasaItens | null>(null);
  casaItensRef.current = casaItens;
  useEffect(() => {
    if (!casaAquiId) return;
    definirCliqueNaCasa((alvo, x, y) => {
      if (alvo.casaId !== casaAquiId || !casaItensRef.current) return false;
      setCasaMenu({ x, y, tipo: alvo.tipo, px: alvo.x, py: alvo.y, pz: alvo.z });
      return true;
    });
    return () => definirCliqueNaCasa(null);
  }, [casaAquiId]);

  /** A peça clicada (techspec-casa-interface-e-baus §05): baú, ferramenta de ofício ou peça presa, com a altura acima do piso. */
  const pecaDoMenu = (): PecaDoMenu | null => {
    if (!casaMenu || !casaItens) return null;
    const { px, py, pz } = casaMenu;
    const dz = mapaDasCasasAgora ? alturaAcimaDoPiso(mapaDasCasasAgora, px, py, pz) : 0;
    if (casaMenu.tipo === 'bau') {
      const bau = casaItens.baus.find(b => b.x === px && b.y === py && b.z === pz);
      return bau ? { tipo: 'bau', bau, dz } : null;
    }
    const oficio = (casaItens.oficios ?? []).find(o => o.x === px && o.y === py && o.z === pz);
    if (oficio) return { tipo: 'oficio', oficio, dz };
    const preso = casaItens.presos.find(p => p.x === px && p.y === py && p.z === pz);
    if (!preso) return null;
    // Em cima de quê (a superfície cujo topo é o pé da peça): "em cima: Mesa grande".
    const sob = [...casaItens.presos, ...casaItens.baus.map(b => ({ defId: b.defId ?? BAU_COMUM, x: b.x, y: b.y, z: b.z }))]
      .find(o => o.x === px && o.y === py && o.z < pz && mobiliaDe(o.defId)?.superficie && o.z + alturaDe(o.defId) === pz);
    return { tipo: 'preso', preso, dz, emCima: dz > 0 ? sob?.defId ?? null : null };
  };
  const pecaNoMenu = pecaDoMenu();
  const usarOficio = (oficio: string, px: number, py: number, x: number, y: number) => {
    const janela = oficio === 'ferraria' ? 'ferreiro' : oficio === 'alfaiataria' ? 'alfaiate' : oficio === 'arcos' ? 'arqueiro' : null;
    setCasaMenu(null);
    if (janela) abrirJanela(janela);
    else abrirMenuDoBoneco(px, py, x, y);
  };
  /** Sentar (§05): anda até o tile da peça; parado nele, o personagem senta (techspec-sentar). */
  const sentarNa = (px: number, py: number) => {
    setCasaMenu(null);
    if (world.status && world.status.tileX === px && world.status.tileY === py) return;
    if (!world.irPara(px, py)) world.sayKey('casa.peca.semCaminho', undefined, 'warn');
  };
  const moverPeca = (alvo: { tipo: 'bau' | 'preso'; id: string }) => {
    if (!casaItens) return;
    if (alvo.tipo === 'bau') {
      const b = casaItens.baus.find(x => x.id === alvo.id);
      if (b) comecarColocacao({ mover: { tipo: 'bau', id: b.id, defId: b.defId ?? BAU_COMUM, nome: nomeDoBau(b, casaItens.baus.indexOf(b)), x: b.x, y: b.y, z: b.z, giro: b.giro } });
      return;
    }
    const p = [...casaItens.presos, ...(casaItens.oficios ?? [])].find(x => x.id === alvo.id);
    if (p) comecarColocacao({ mover: { tipo: 'preso', id: p.id, defId: p.defId, nome: p.nome, x: p.x, y: p.y, z: p.z, giro: p.giro ?? 0 } });
  };
  /** Girar, subir ou descer a peça do menu sem a faixa (o mesmo PATCH do mover). */
  const ajustarPeca = (peca: PecaDoMenu, dDz: number, dGiro: number) => {
    const alvo = peca.tipo === 'bau' ? peca.bau : peca.tipo === 'oficio' ? peca.oficio : peca.preso;
    const defId = peca.tipo === 'bau' ? (peca.bau.defId ?? BAU_COMUM) : alvo.defId as string;
    const body = { x: alvo.x, y: alvo.y, z: alvo.z + dDz, giro: ((alvo.giro ?? 0) + dGiro) % Math.max(1, girosDe(defId)) };
    void agirCasa(() => (peca.tipo === 'bau' ? api.moverBauDaCasa(hid, peca.bau.id, body) : api.moverNaCasa(hid, (alvo as { id: string }).id, body)));
  };
  /** O Boneco de Punguista da casa, o bônus dele e o menu em anel (§06): o boneco é um manequim da sala. */
  const bonecoDaCasa = casaItens?.oficios?.find(o => o.oficio === 'treino') ?? null;
  const regraBoneco = casaRegras.find(x => x.oficio === 'treino');
  const bonusDoBoneco = bonecoDaCasa?.bonusAtivo && regraBoneco ? resumoBonus(regraBoneco) : undefined;
  function abrirMenuDoBoneco(px: number, py: number, x: number, y: number) {
    setCasaMenu(null);
    const id = world.dummyEm(px, py);
    if (id == null) {
      world.say(t('casa.oficio.bonecoLonge'), 'warn');
      return;
    }
    setDummyMenu({ id, x, y });
  }
  /** Os ofícios com o bônus da casa valendo para quem está aqui (o selo no menu Ofícios do topo, §05.4). */
  const bonusDaCasa = new Set((casaItens?.oficios ?? []).filter(o => o.bonusAtivo).map(o =>
    o.oficio === 'ferraria' ? 'ferreiro' : o.oficio === 'alfaiataria' ? 'alfaiate' : o.oficio === 'arcos' ? 'arqueiro' : o.oficio));
  const bauDaJanela = bauAberto ? casaItens?.baus.find(b => b.id === bauAberto) ?? null : null;
  const nomeAqui = casaAqui ? nomeDaCasa(casaItens?.nome ?? casaAqui.nome, casaAqui.dono) : '';

  /* A placa da casa (techspec-casa-interface-e-baus §09): qualquer um clica; o rótulo sobe sobre ela e a janela abre. */
  useEffect(() => {
    definirCliqueNaPlaca((p, x, y) => {
      setPlaca({ p, x, y, ate: performance.now() + 6000, dados: null });
      void api.placaDaCasa(p.casaId).then(d => setPlaca(a => (a && a.p.casaId === p.casaId ? { ...a, dados: d } : a))).catch(() => {});
    });
    return () => definirCliqueNaPlaca(null);
  }, []);
  const [, setRelogioPlaca] = useState(0);
  useEffect(() => {
    if (!placa) return;
    const id = window.setTimeout(() => setRelogioPlaca(n => n + 1), Math.max(0, placa.ate - performance.now()) + 50);
    return () => window.clearTimeout(id);
  }, [placa]);

  /** A lista de acesso (só o dono): troca de papel, tira, abre ou fecha a casa. */
  const mudarAcesso = async (fn: () => Promise<MinhaCasa>) => {
    if (casaOcupada) return;
    setCasaOcupada(true);
    try {
      setMinhaAcesso(await fn());
      setCasasVersao(v => v + 1);
    } catch (err) {
      world.say(err instanceof ApiError && err.message ? err.message : t('comum.recusouPedido'), 'warn');
    } finally {
      setCasaOcupada(false);
    }
  };

  useEffect(() => {
    if (!fabAberto.viajar) return;
    let vivo = true;
    void api.minhaCasa()
      .then(c => { if (vivo) setDestinoCasa(c ? destinoDaCasa(c) : null); })
      .catch(() => {});
    return () => { vivo = false; };
  }, [fabAberto.viajar]);

  const fecharCorretor = (motivo: 'close' | 'longe' | 'disconnect' | 'mapa') => {
    const cur = corretorRef.current;
    if (!cur) return;
    if (motivo !== 'disconnect' && motivo !== 'mapa')
      npcFalaRef.current(cur.remoteId, cur.nome, cur.papel, 'despedida');
    setCorretor(null);
  };

  useEffect(() => {
    if (!world.ready) fecharCorretor('disconnect');
  }, [world.ready]);

  useEffect(() => {
    if (!corretor || corretor.viaMenu || !world.status) return;
    if (longeDoNpc(world.status.tileX, world.status.tileY, corretor.x, corretor.y, corretor.alcance))
      fecharCorretor('longe');
  }, [corretor, world.status]);

  const fecharBanco = (motivo: 'close' | 'longe' | 'disconnect' | 'mapa') => {
    const cur = bancoRef.current;
    if (!cur) return;
    if (motivo !== 'disconnect' && motivo !== 'mapa')
      npcFalaRef.current(cur.remoteId, cur.nome, cur.papel, 'despedida');
    setBanco(null);
    if (mochilaPeloBanco.current) {
      mochilaPeloBanco.current = false;
      setPackOpen(false);
    }
  };

  useEffect(() => {
    if (!world.ready) fecharBanco('disconnect');
  }, [world.ready]);

  useEffect(() => {
    if (!banco || banco.viaMenu || !world.status) return;
    if (longeDoNpc(world.status.tileX, world.status.tileY, banco.x, banco.y, banco.alcance))
      fecharBanco('longe');
  }, [banco, world.status]);

  const hadDeal = useRef(false);
  useEffect(() => {
    if (world.deal) hadDeal.current = true;
    else if (hadDeal.current) {
      hadDeal.current = false;
      setPackTick(n => n + 1);
    }
  }, [world.deal]);

  const closeTell = useCallback((name: string) => {
    const key = tellKey(name);
    world.markTellRead(name);
    setOpenTells(cur => cur.filter(t => t.key !== key));
  }, [world]);

  useEffect(() => {
    let live = true;
    const load = async () => {
      try {
        const next = await api.getGuildMe();
        if (live) setHouse(next ?? null);
      } catch { /* a aba some se a leitura falhar */ }
    };
    void load();
    const t = window.setInterval(() => { void load(); }, 8000);
    return () => { live = false; window.clearInterval(t); };
  }, [character?.id, houseTick]);

  const refreshHouse = useCallback((text?: string) => {
    if (text) world.say(text, 'system');
    setHouseTick(n => n + 1);
  }, [world]);

  const addFriend = useCallback(async (name: string) => {
    try {
      const row = await api.addFriend(name);
      setFriendNames(cur => new Set(cur).add(row.name.trim().toLowerCase()));
      recarregarAmigosRef.current();
    } catch {
      /* o aviso HTTP aparece se a lista estiver aberta */
    }
    dismissMenu();
  }, [dismissMenu]);

  /** Menu do jogador: "Remover dos amigos". A lista pode não estar carregada: busca o id pelo nome. */
  const removerAmigoPeloNome = useCallback(async (name: string) => {
    const alvo = name.trim().toLowerCase();
    dismissMenu();
    try {
      const lista = await api.listFriends();
      const f = lista.find(a => a.name.trim().toLowerCase() === alvo);
      if (!f) return;
      await api.removeFriend(f.id);
      setFriendNames(cur => { const n = new Set(cur); n.delete(alvo); return n; });
      recarregarAmigosRef.current();
      world.sayKey('menu.jogador.amigoRemovido', { nome: f.name }, 'system');
    } catch (err) {
      world.say(err instanceof ApiError ? err.message : t('comum.recusouPedido'), 'warn');
    }
  }, [dismissMenu]);

  esquecerDueloRef.current = world.esquecerDuelo;

  const { ordem, setOrdem, cacando } = useCacadaAtiva(mapaId, world.huntFimSeq);
  cacandoRef.current = cacando;
  // O cartão "Enquanto você esteve fora" não abre mais a janela sozinho (techspec-hud-v3 §20): o idle fica sempre na
  // pílula, e o cartão espera dentro da janela até o jogador abrir.
  // O idle entra minimizado (techspec-hud-v3 §18): a caçada que acabou de começar fecha a janela e fica na pílula.
  // Resgate do corpo (techspec-resgate-do-corpo): a caçada em que ele morreu, para o "Continuar caçada" depois do
  // resgate. A ordem some logo depois da morte (a caçada encerra), então guarda a última e quando ela acabou.
  const ultimaOrdem = useRef<{ ordem: HuntOrder; fim: number } | null>(null);
  const [cacadaPerdida, setCacadaPerdida] = useState<HuntOrder | null>(null);
  useEffect(() => {
    if (ordem) ultimaOrdem.current = { ordem, fim: Number.POSITIVE_INFINITY };
    else if (ultimaOrdem.current && ultimaOrdem.current.fim === Number.POSITIVE_INFINITY) ultimaOrdem.current.fim = Date.now();
  }, [ordem]);
  useEffect(() => {
    if (!dead) return;
    const u = ultimaOrdem.current;
    setCacadaPerdida(u && Date.now() - u.fim < 30_000 ? u.ordem : null);
  }, [dead]);
  // Resgate do corpo no diário (resgate-corpo-prototipo): uma linha quando o corpo aparece e em cada etapa.
  const corpoAvisado = useRef<string>('');
  useEffect(() => {
    const c = world.corpoPendente;
    if (!c) { corpoAvisado.current = ''; return; }
    const chave = `${c.mapa}:${c.itens}`;
    if (corpoAvisado.current === chave) return;
    corpoAvisado.current = chave;
    const seg = Math.max(0, Math.round((c.ate - Date.now()) / 1000));
    world.sayKey('resgate.diario.corpo', {
      lugar: nomeDoLugarDoCorpo(c.mapa), n: c.itens, tempo: `${Math.floor(seg / 60)}:${String(seg % 60).padStart(2, '0')}`
    }, 'warn');
  }, [world.corpoPendente]);
  const etapaResgate = useRef(0);
  useEffect(() => {
    const r = world.resgate;
    if (r.etapa === etapaResgate.current) return;
    etapaResgate.current = r.etapa;
    if (r.etapa === 1) world.sayKey('resgate.diario.indo', undefined, 'note');
    else if (r.etapa === 2) world.sayKey('resgate.diario.ok', undefined, 'gain');
    else if (r.etapa === 3) world.say(existe(`resgate.motivo.${r.motivo}`) ? t(`resgate.motivo.${r.motivo}`) : motivoCurto(r.motivo), 'warn');
  }, [world.resgate]);
  const continuarCacada = () => {
    const o = cacadaPerdida;
    world.fecharResgate();
    setCacadaPerdida(null);
    if (!o) return;
    void api.startHunt({
      huntId: o.huntId, filtro: [...o.filtro], modo: 'automatico', aoVerJogador: o.aoVerJogador,
      aoEncher: o.aoEncher, raroAbaixoDe: o.raroAbaixoDe
    }).then(board => setOrdem(board.ordem))
      .catch(err => world.say(err instanceof ApiError ? err.message : t('comum.recusouPedido'), 'warn'));
  };

  const ordemAntes = useRef<string | null>(null);
  useEffect(() => {
    const id = ordem?.startedAt ?? null;
    const comecou = !!id && ordemAntes.current === null;
    ordemAntes.current = id;
    if (comecou) setHuntOpen(false);
  }, [ordem?.startedAt]);

  // Coleta (techspec-coleta §07): o gump ao vivo vem da sala; o resto, de GET /api/coleta.
  const coletaApi = useColeta(world.coleta, !!world.net, r => {
    const total = Object.values(r.toras).reduce((a, b) => a + b, 0);
    world.sayKey(recursoDe(r.recurso).t.resumo, { n: total, tentativas: r.tentativas }, 'note');
  });
  const coletaVivo = coletaApi.vivo;
  const coletando = !!coletaVivo;
  // O idle entra sempre minimizado (techspec-hud-v3 §18).
  const [coletaMin, setColetaMin] = useState(true);
  const [coletaCancelando, setColetaCancelando] = useState(false);
  const recarregarColetaRef = useRef(coletaApi.recarregar);
  recarregarColetaRef.current = coletaApi.recarregar;
  // Entrou no mundo: lê a coleta (e o resumo de uma que acabou desconectado).
  useEffect(() => { if (world.ready) void recarregarColetaRef.current(); }, [world.ready]);
  // Abrir o Viajar relê a coleta: a machadinha pode ter chegado depois (Ferraria, GM, troca).
  useEffect(() => { if (fabAberto.viajar || fabAberto.recursos) void recarregarColetaRef.current(); }, [fabAberto.viajar, fabAberto.recursos]);
  const travarColetaRef = useRef(world.travarColeta);
  travarColetaRef.current = world.travarColeta;
  useEffect(() => {
    // Na sala, o `co` já trava; no mock é aqui.
    if (!world.net) travarColetaRef.current(coletando);
  }, [coletando, world.net]);
  const cancelarColeta = useCallback(async (destino?: string) => {
    setColetaCancelando(true);
    try {
      await api.cancelarColeta(destino);
      await coletaApi.recarregar();
    } catch (e) {
      world.say(e instanceof Error ? e.message : t('coleta.erroIr'), 'warn');
    } finally {
      setColetaCancelando(false);
    }
  }, [coletaApi, world]);

  // Suporte: quantos chamados esperam uma resposta do jogador (a linha do menu Mais fica dourada).
  const lerResumoSuporte = useCallback(() => {
    void api.suporteResumo().then(r => setSuportePede(r.precisaDeVoce)).catch(() => { /* a linha só não fica dourada */ });
  }, []);
  useEffect(() => {
    lerResumoSuporte();
    return aoAvisoDeSuporte(lerResumoSuporte);
  }, [lerResumoSuporte]);

  // Eventos agendados (techspec-eventos): o próximo horário; relê quando a janela fecha e a cada 5 min. Os prêmios
  // chegam no correio (techspec-correio).
  const lerPremiosEvento = useCallback(() => {
    void api.eventoAgenda().then(a => {
      const p = a.proximos[0];
      setProximoEvento(p ? { hora: p.hora, emMs: p.emMs, tipo: p.tipo } : null);
    }).catch(() => { /* a linha só não fica dourada */ });
  }, []);
  useEffect(() => {
    lerPremiosEvento();
    const id = window.setInterval(lerPremiosEvento, 300_000);
    return () => window.clearInterval(id);
  }, [lerPremiosEvento]);

  // Indicações (techspec-indicacoes §04): a linha do Mais só aparece com as indicações ligadas no console.
  useEffect(() => {
    let vivo = true;
    void api.indicacoes().then(r => { if (vivo) setIndicarAtivo(r.ativo); }).catch(() => { /* sem a linha */ });
    return () => { vivo = false; };
  }, [character?.id]);

  // Correio (techspec-correio §06): as cartas novas acendem a carta flutuante e a linha do Mais. Relê a cada minuto,
  // no aviso 204 (carta nova: a carta entra voando) e nos avisos de prêmio.
  const lerCorreio = useCallback((chegou = false) => {
    void api.correioResumo().then(r => setCorreio(c => ({
      novas: r.novas,
      pendentes: r.pendentes,
      chegou: chegou && r.novas > c.novas
    }))).catch(() => { /* a carta só não aparece */ });
  }, []);
  useEffect(() => {
    if (!character?.id) return;
    lerCorreio();
    const id = window.setInterval(() => lerCorreio(), 60_000);
    const sai = aoCorreio(chegou => lerCorreio(chegou));
    return () => { window.clearInterval(id); sai(); };
  }, [lerCorreio, character?.id]);
  useEffect(() => {
    if (!correio.chegou) return;
    const id = window.setTimeout(() => setCorreio(c => ({ ...c, chegou: false })), 1200);
    return () => window.clearTimeout(id);
  }, [correio.chegou]);

  const dadosParaSuporte = (): DadosDoJogo => {
    const st = world.status;
    return {
      modo: modo === 'cel' || modo === 'deitado' ? 'cel' : modo === 'tablet' ? 'tablet' : 'pc',
      lugar: st?.place || world.sala.mapaNome || '',
      mapa: world.sala.mapaId,
      x: st?.tileX,
      y: st?.tileY,
      canal: st?.canal,
      cacando,
      grupo: !!world.party,
      duelo: !!world.duelo,
      versaoFront: VERSAO_FRONT,
      mundo: st?.mundoNome || (st?.mundoVersao ? `v${st.mundoVersao}` : null),
      // Só linhas com chave: avisos do sistema. Fala de jogador nunca vai junto.
      diario: world.journal.filter(l => !!l.chave).slice(-6).map(l => ({ at: l.at, texto: t(l.chave!, l.args) }))
    };
  };
  const { amigos, erro: erroAmigos, recarregar: recarregarAmigos } = useAmigos(friendsOpen || pop === 'social');
  const { novidade, marcarLojaVista } = useNovidadeLoja(world.status?.mundoVersao);
  const chatVisivel = compacto ? chatAberto : !chatMin;
  // Com uma conversa na frente, o canal da aba não está à vista: continua contando as não lidas dele.
  const { aba: abaChat, setAba: setAbaChat, naoLidas: naoLidasChat, total: totalChat } = useChatNaoLidas(world, chatVisivel && !conversaChat, playerName);
  /* A conversa à vista conta como lida (world.openTell) até sair da frente, fechar ou o chat minimizar. */
  const conversaVista = chatVisivel && conversaChat ? conversasChat.find(c => c.key === conversaChat)?.label ?? null : null;
  const { openTell: verTell, markTellRead: largarTell } = world;
  useEffect(() => {
    if (!conversaVista) return;
    verTell(conversaVista);
    return () => largarTell(conversaVista);
  }, [conversaVista, verTell, largarTell]);
  recarregarAmigosRef.current = () => { void recarregarAmigos(); };

  useEffect(() => {
    setFriendNames(new Set(amigos.map(a => a.name.trim().toLowerCase())));
  }, [amigos]);

  useEffect(() => {
    const cidade = character?.homeCity ?? 'minoc';
    let vivo = true;
    void carregarCatalogo().then(lista => {
      if (!vivo) return;
      setNatal(registroPorCidade(lista, cidade)?.nome ?? cidade);
    }).catch(() => { if (vivo) setNatal(cidade); });
    return () => { vivo = false; };
  }, [character?.homeCity]);

  useEffect(() => {
    const mundo = mundoRef.current;
    if (!mundo) return;
    if (modo !== 'cel') {
      mundo.style.removeProperty('--barra-h');
      return;
    }
    const barra = mundo.querySelector('.skillbar');
    if (!(barra instanceof HTMLElement)) return;
    const medir = () => mundo.style.setProperty('--barra-h', `${barra.offsetHeight}px`);
    medir();
    const obs = new ResizeObserver(medir);
    obs.observe(barra);
    return () => {
      obs.disconnect();
      mundo.style.removeProperty('--barra-h');
    };
  }, [modo]);

  useEffect(() => {
    const mundo = mundoRef.current;
    if (!mundo) return;
    const fechar = (e: PointerEvent) => {
      const alvo = e.target;
      if (!(alvo instanceof Element) || alvo.closest('.pop, .mt, .topbar__stamina, .p-nb')) return;
      setPop(null);
    };
    mundo.addEventListener('pointerdown', fechar);
    return () => mundo.removeEventListener('pointerdown', fechar);
  }, []);

  const atenderNpc = (
    id: string, nome: string, titulo: string, x: number, y: number,
    temLoja: boolean, temCorretor: boolean, temBanco: boolean, remoteId: number, alcance: number,
    viaMenu: boolean
  ) => {
    const papel = papelDoTitulo(titulo);
    const raio = alcance || NPC_ALCANCE_PADRAO;
    if (!viaMenu) {
      const here = tileRef.current;
      if (here && longeDoNpc(here.x, here.y, x, y, raio)) {
        npcFalaRef.current(remoteId, nome, papel, 'longe');
        return;
      }
    }
    if (temLoja) {
      const prev = shopRef.current;
      if (prev && prev.npcId !== id)
        npcFalaRef.current(prev.remoteId, prev.nome, prev.papel, 'despedida');
      const outro = corretorRef.current;
      if (outro) npcFalaRef.current(outro.remoteId, outro.nome, outro.papel, 'despedida');
      const baú = bancoRef.current;
      if (baú) npcFalaRef.current(baú.remoteId, baú.nome, baú.papel, 'despedida');
      setCorretor(null);
      setBanco(null);
      setShop({ npcId: id, nome, x, y, remoteId, papel, alcance: raio, viaMenu });
      npcFalaRef.current(remoteId, nome, papel, 'saudacao');
      return;
    }
    if (temCorretor) {
      const prev = corretorRef.current;
      if (prev && prev.npcId !== id)
        npcFalaRef.current(prev.remoteId, prev.nome, prev.papel, 'despedida');
      const outro = shopRef.current;
      if (outro) npcFalaRef.current(outro.remoteId, outro.nome, outro.papel, 'despedida');
      const baú = bancoRef.current;
      if (baú) npcFalaRef.current(baú.remoteId, baú.nome, baú.papel, 'despedida');
      setShop(null);
      setBanco(null);
      const fala = falaDoNpc(papel, 'saudacao');
      falarNpcRef.current(remoteId, fala);
      setCorretor({ npcId: id, nome, x, y, remoteId, papel, fala, alcance: raio, viaMenu });
      return;
    }
    if (temBanco) {
      const prev = bancoRef.current;
      if (prev && prev.npcId !== id)
        npcFalaRef.current(prev.remoteId, prev.nome, prev.papel, 'despedida');
      const loja = shopRef.current;
      if (loja) npcFalaRef.current(loja.remoteId, loja.nome, loja.papel, 'despedida');
      const outro = corretorRef.current;
      if (outro) npcFalaRef.current(outro.remoteId, outro.nome, outro.papel, 'despedida');
      setShop(null);
      setCorretor(null);
      setBanco({ npcId: id, nome, x, y, remoteId, papel, alcance: raio, viaMenu });
      npcFalaRef.current(remoteId, nome, papel, 'saudacao');
      return;
    }
    npcFalaRef.current(remoteId, nome, papel, 'semLoja');
  };
  atenderRef.current = atenderNpc;

  function abertaJanela(j: Janela): boolean {
    switch (j) {
      case 'perfil': return profileOpen;
      case 'mochila': return packOpen;
      case 'mercado': return marketOpen;
      case 'loja': return lojaOpen;
      case 'cacar': return huntOpen;
      case 'ordens': return open.has('ordens');
      case 'guilda': return guildOpen;
      case 'amigos': return friendsOpen;
      case 'config': return settingsOpen;
      case 'suporte': return suporteOpen;
      case 'correio': return correioOpen;
      case 'indicar': return indicarOpen;
      case 'rankings': return rankingsOpen;
      case 'vender': return venderOpen;
      case 'dano': return dpsOpen;
      case 'gm': return gmOpen;
      case 'ferreiro': return ferreiroOpen;
      case 'alfaiate': return alfaiateOpen;
      case 'arqueiro': return arqueiroOpen;
      case 'npc': return !!shop;
      case 'corretor': return !!corretor;
      case 'banco': return !!banco;
      case 'evento': return eventoOpen;
      case 'desempenho': return desempenhoOpen;
      case 'tell': return openTells.length > 0;
    }
  }

  function listaAbertas(): Janela[] {
    const ids: Janela[] = [
      'perfil', 'mochila', 'mercado', 'loja', 'cacar', 'ordens', 'guilda', 'amigos', 'config',
      'dano', 'gm', 'ferreiro', 'alfaiate', 'arqueiro', 'npc', 'corretor', 'banco',
      'evento', 'desempenho', 'tell', 'suporte', 'rankings', 'vender', 'correio', 'indicar'
    ];
    return ids.filter(abertaJanela);
  }

  function fecharUma(j: Janela) {
    switch (j) {
      case 'perfil': setProfileOpen(false); break;
      case 'mochila': setPackOpen(false); break;
      case 'mercado': setMarketOpen(false); break;
      case 'loja': setLojaOpen(false); break;
      case 'cacar': setHuntOpen(false); break;
      case 'ordens': close('ordens'); break;
      case 'guilda': setGuildOpen(false); break;
      case 'amigos': setFriendsOpen(false); break;
      case 'config': setSettingsOpen(false); break;
      case 'suporte': setSuporteOpen(false); break;
      case 'correio': setCorreioOpen(false); setCorreioAbrir(null); break;
      case 'indicar': setIndicarOpen(false); break;
      case 'rankings': setRankingsOpen(false); break;
      case 'vender': setVenderOpen(false); break;
      case 'dano': setDpsOpen(false); break;
      case 'gm': setGmOpen(false); break;
      case 'ferreiro': setFerreiroOpen(false); break;
      case 'alfaiate': setAlfaiateOpen(false); break;
      case 'arqueiro': setArqueiroOpen(false); break;
      case 'npc': fecharLoja('close'); break;
      case 'corretor': fecharCorretor('close'); break;
      case 'banco': fecharBanco('close'); break;
      case 'evento': setEventoOpen(false); break;
      case 'desempenho': setDesempenhoOpen(false); break;
      case 'tell':
        for (const item of openTells) world.markTellRead(item.label);
        setOpenTells([]);
        break;
    }
  }

  function fecharOutras(exceto: Janela) {
    for (const outra of listaAbertas()) {
      if (outra === exceto) continue;
      if (exceto === 'banco' && outra === 'mochila') continue;
      fecharUma(outra);
    }
  }

  abrirJanelaRef.current = j => abrirJanela(j);
  function abrirJanela(j: Janela) {
    setPop(null);
    if (compacto) {
      setChatAberto(false);
      fecharOutras(j);
    }
    switch (j) {
      case 'perfil': setProfileOpen(true); break;
      case 'mochila':
        if (banco) {
          mochilaPeloBanco.current = false;
          fecharBanco('close');
        }
        setPackOpen(true);
        break;
      case 'mercado': setMarketOpen(true); break;
      case 'loja': setLojaOpen(true); break;
      case 'cacar': setHuntOpen(true); break;
      case 'ordens': setOpen(cur => { const next = new Set(cur); next.add('ordens'); return next; }); break;
      case 'guilda': setGuildOpen(true); break;
      case 'amigos': setFriendsOpen(true); break;
      case 'config': setSettingsOpen(true); break;
      case 'suporte': setSuporteOpen(true); break;
      case 'correio': setCorreioOpen(true); break;
      case 'indicar': setIndicarOpen(true); break;
      case 'rankings': setRankingsOpen(true); break;
      case 'vender': setVenderOpen(true); break;
      case 'dano': setDpsOpen(true); break;
      case 'gm': setGmOpen(true); break;
      case 'ferreiro': setFerreiroOpen(true); break;
      case 'alfaiate': setAlfaiateOpen(true); break;
      case 'arqueiro': setArqueiroOpen(true); break;
      case 'evento': setEventoOpen(true); break;
      case 'desempenho': setDesempenhoOpen(true); break;
      default: break;
    }
    ultimasJanelas.current = [...ultimasJanelas.current.filter(x => x !== j), j];
  }

  function alternarJanela(j: Janela) {
    if (j === 'mochila' && banco) {
      mochilaPeloBanco.current = false;
      fecharBanco('close');
      setPackOpen(true);
      setPop(null);
      return;
    }
    if (abertaJanela(j)) fecharUma(j);
    else abrirJanela(j);
  }
  alternarRef.current = alternarJanela;

  function menuTravado(m: ItemMenu): boolean {
    if (!m.trava) return false;
    if (cacando) return true;
    return m.id === 'banco' && !world.sala.npcs.some(n => n.temBanco);
  }

  function abrirBanco() {
    if (cacando) {
      world.say(t('hud.trava.aviso', { menu: t('banco.titulo'), cidade: natal }), 'warn');
      return;
    }
    const b = world.sala.npcs.find(n => n.temBanco);
    if (!b) {
      world.say(t('hud.banco.semBanqueiro'), 'warn');
      return;
    }
    atenderNpc(b.id, b.nome, b.titulo, b.x, b.y, false, false, true, b.remoteId, b.alcance, true);
    abrirJanela('banco');
  }

  function menuHud(m: ItemMenu) {
    if (m.pop) {
      if (compacto) setChatAberto(false);
      setPop(atual => atual === m.pop ? null : m.pop!);
      return;
    }
    if (m.abre === 'banco') {
      if (menuTravado(m)) {
        world.say(t('hud.trava.aviso', { menu: t(m.chave), cidade: natal }), 'warn');
        return;
      }
      abrirBanco();
      return;
    }
    if (m.abre) alternarJanela(m.abre);
  }
  menuHudRef.current = menuHud;

  /** Topo › Treinar (techspec-hud-v3 §24): a skill escolhida leva ao manequim de treino mais perto da sala. */
  function treinarNoManequim(skill: DummyTrainSkill) {
    setPop(null);
    // Na casa (§06): o boneco da casa, nunca o treino automático de Minoc. Sem boneco, o menu já vem travado.
    if (naMinhaCasa) {
      if (!bonecoDaCasa) { world.say(t('casa.oficio.semBoneco'), 'warn'); return; }
      const id = world.dummyEm(bonecoDaCasa.x, bonecoDaCasa.y);
      if (id == null) { world.say(t('casa.oficio.bonecoLonge'), 'warn'); return; }
      void pickDummySkill(id, skill);
      return;
    }
    // Ao vivo, o servidor decide: só inocente, sempre em Minoc, no canal que tiver manequim livre.
    if (world.net) {
      void prepararArma(skill).then(ok => { if (ok) world.treinarAuto(skill); });
      return;
    }
    const id = world.manequimDeTreinoPerto();
    if (id == null) {
      world.say(t('hud.treinar.semManequim'), 'warn');
      return;
    }
    void pickDummySkill(id, skill);
  }

  function abrirConversa(nome: string) {
    if (friendNames.has(nome.trim().toLowerCase())) {
      abrirConversaChat(nome, true);
      return;
    }
    openTell(nome);
  }

  /**
   * Mensagem privada com amigo (techspec-hud-v3 §23): uma aba com o nome dele no chat do jogo. `mostrar` põe a aba na
   * frente e abre o chat (clique na lista de Amigos ou "Mensagem" no menu); a mensagem que chega só cria a aba.
   */
  function abrirConversaChat(nome: string, mostrar: boolean) {
    const key = tellKey(nome);
    setConversasChat(cur => {
      if (cur.some(c => c.key === key)) return cur;
      const next = [...cur, { key, label: nome }];
      while (next.length > MAX_CONVERSAS) {
        const i = next.findIndex(c => c.key !== conversaChat && c.key !== key);
        next.splice(i < 0 ? 0 : i, 1);
      }
      return next;
    });
    if (!mostrar) return;
    setConversaChat(key);
    // §24: o cursor já vai para a entrada da conversa, pronto para digitar
    setFocoFala(Date.now());
    if (compacto) {
      setPop(null);
      setFriendsOpen(false);
      setChatAberto(true);
    } else if (chatMin) {
      mudarChatMin(false);
    }
    dismissMenu();
  }
  /* Mensagem de amigo chegando: a aba vem para a frente (senão ninguém via a mensagem), a não ser que o jogador
     esteja digitando no chat agora. */
  conversaNovaRef.current = nome => {
    abrirConversaChat(nome, false);
    const foco = document.activeElement;
    const digitando = foco instanceof HTMLInputElement && !!foco.closest('.ct-dizer');
    if (!digitando) setConversaChat(tellKey(nome));
  };

  function fecharConversaChat(key: string) {
    setConversasChat(cur => cur.filter(c => c.key !== key));
    setConversaChat(cur => (cur === key ? null : cur));
  }


  function xDoPop(id: PopId): number {
    if (id === 'cidade' || id === 'social' || (id === 'mais' && modo === 'cel')) return 8;
    const mundo = mundoRef.current;
    const btn = mundo?.querySelector(`[data-menu="${id}"]`);
    if (!mundo || !(btn instanceof HTMLElement) || btn.offsetParent === null) return 8;
    const br = btn.getBoundingClientRect();
    const wr = mundo.getBoundingClientRect();
    // O resumo da fadiga é mais largo e nasce centrado no anel.
    if (id === 'fadiga')
      return Math.max(8, Math.min(br.left - wr.left + br.width / 2 - LARGURA_POP_FADIGA / 2, wr.width - LARGURA_POP_FADIGA - 10));
    return Math.max(8, Math.min(br.left - wr.left - 6, wr.width - 310));
  }

  function mudarChatMin(min: boolean) {
    setChatMin(min);
    try { localStorage.setItem('uoidle.chat.min', min ? '1' : '0'); } catch { /* sem storage */ }
  }

  /** Enter: no PC abre o chat na aba Local com o campo pronto; no celular foca a linha de fala. */
  function falarPerto() {
    setPop(null);
    setConversaChat(null);
    if (!compacto) {
      if (chatMin) mudarChatMin(false);
      setAbaChat('local');
    } else if (chatAberto) {
      setAbaChat('local');
    }
    setFocoFala(Date.now());
  }
  falarRef.current = falarPerto;

  function alternarChat() {
    setPop(null);
    if (chatAberto) { setChatAberto(false); return; }
    for (const j of listaAbertas()) fecharUma(j);
    setChatAberto(true);
  }

  function voltarDaCacada() {
    void pararCacada(setOrdem, texto => world.say(texto, 'warn'));
    setPop(null);
  }

  const modoAnterior = useRef(modo);
  useEffect(() => {
    const antes = modoAnterior.current;
    modoAnterior.current = modo;
    const eraCompacto = antes === 'cel' || antes === 'deitado';
    const agoraCompacto = modo === 'cel' || modo === 'deitado';
    if (!agoraCompacto || eraCompacto) return;
    setMinimapaCompacto(false);
    const lista = ultimasJanelas.current.filter(abertaJanela);
    if (lista.length <= 1) return;
    const fica = lista[lista.length - 1];
    for (const j of lista) if (j !== fica && !(fica === 'banco' && j === 'mochila')) fecharUma(j);
  }, [modo]);

  fecharMapaRef.current = () => {
    fecharLoja('mapa');
    fecharCorretor('mapa');
    fecharBanco('mapa');
    setViagemMenu(null);
    setPop(null);
  };
  aoAbrirTellRef.current = () => {
    if (!compacto) return;
    setPop(null);
    setChatAberto(false);
    fecharOutras('tell');
  };

  const pipAmigos = amigos.some(a => (world.unreadTells[a.name.trim().toLowerCase()] ?? 0) > 0);
  const naoLidasAmigos = amigos.reduce((s, a) => s + (world.unreadTells[a.name.trim().toLowerCase()] ?? 0), 0);
  const amigosOn = amigos.filter(a => a.online).length;
  const tellsVisiveis = compacto ? openTells.slice(-1) : openTells;
  const minimapaVisivel = compacto ? minimapaCompacto : open.has('mapa');
  const portalAberto = world.portal ?? viagemMenu;
  const destinosDoMenu = destinoCasa && !coletando ? [destinoCasa, ...world.sala.viagens] : world.sala.viagens;

  return (
    <ModoTelaContext.Provider value={modo}>
    <main ref={mundoRef} className="world" data-modo={modo}>
      <canvas
        ref={world.canvasRef}
        className={`world__canvas${dead ? ' world__canvas--ghost' : ''}`}
        aria-label={t('mundo.canvasAria', { lugar: 'Britain', nome: playerName })}
      />

      {/* A tela de carregamento (techspec-loading): entrada, viagem, reconexão e a falha da entrada, com os botões. */}
      <TelaCarregamento carga={world.carga} falha={world.failure} shard={shardNome} onTentar={entrarDeNovo} onVoltar={back} />

      <BarraTopo
        quem={(
          <button
            type="button"
            className="topbar__who"
            aria-label={t('perfil.abrir')}
            aria-pressed={profileOpen}
            title={`${t('perfil.titulo')} (${rotuloTecla(teclaDe('perfil'))})`}
            onClick={() => alternarJanela('perfil')}
          >
            <span className="topbar__avatar">
              <canvas
                ref={world.paperdollRef}
                className="topbar__doll"
                width={80}
                height={80}
                aria-hidden="true"
              />
            </span>
            <span className="topbar__meta">
              <span className={`topbar__name${gmOculto ? ' topbar__name--oculto' : ''}${marca ? ' topbar__name--staff' : ''}`}>
                {nomeMarcado}
                {!!world.vip && world.vip.ate > Date.now() && (
                  <span
                    className="topbar__vip"
                    role="button"
                    tabIndex={0}
                    title={t('vip.chip')}
                    onClick={e => { e.stopPropagation(); setLojaAba('vip'); abrirJanela('loja'); }}
                    onKeyDown={e => {
                      if (e.key !== 'Enter' && e.key !== ' ') return;
                      e.preventDefault();
                      e.stopPropagation();
                      setLojaAba('vip');
                      abrirJanela('loja');
                    }}
                  >
                    <CoroaVip />
                  </span>
                )}
              </span>
              <span className="topbar__where">{world.status?.place ?? character?.homeCity ?? 'Britain'}</span>
              {/* Quem assumiu o controle no meio de uma briga não vai parar para
                  conferir num painel: o modo tem de ser legível sem abrir o gump. */}
              {(world.huntManual || gmOculto) && (
                <span className="topbar__selos">
                  {world.huntManual && (
                    <span className="topbar__modo">{t('cacar.modo.manual')}</span>
                  )}
                  {gmOculto && (
                    <span className="topbar__oculto">{t('gm.oculto.selo')}</span>
                  )}
                </span>
              )}
            </span>
          </button>
        )}
        pop={pop}
        janelaAberta={id => abertaJanela(id as Janela)}
        menuTravado={menuTravado}
        pips={{ mais: suportePede > 0 || correio.novas > 0 }}
        onMenu={menuHud}
        status={world.status}
        prata={wallet.silver}
        ouro={lojaOuro ?? wallet.gold}
        lojaAberta={lojaOpen}
        novidade={novidade}
        cacandoDesde={ordem?.startedAt ?? null}
        onLoja={() => { alternarJanela('loja'); marcarLojaVista(); }}
        onFadiga={() => { setChatAberto(false); setPop(atual => (atual === 'fadiga' ? null : 'fadiga')); }}
      />
      {(world.status?.criminalLeft ?? 0) > 0 && (
        <div className="criminal-bar mt-criminal" role="status">
          {t('mundo.criminalRestante', { tempo: formatarCriminal(world.status?.criminalLeft ?? 0) })}
        </div>
      )}
      <NavCelular
        pop={pop}
        huntAberto={huntOpen}
        chatAberto={chatAberto}
        pipChat={totalChat > 0}
        pipSocial={pipAmigos}
        pipMais={suportePede > 0 || correio.novas > 0}
        cacandoDesde={ordem?.startedAt ?? null}
        onCacar={() => alternarJanela('cacar')}
        onPop={id => { setChatAberto(false); setPop(atual => atual === id ? null : id); }}
        onChat={alternarChat}
      />

      {world.avisoAtual && (
        <AvisoFaixa
          key={world.avisoAtual.id}
          atual={world.avisoAtual}
          onFechar={world.fecharAviso}
        />
      )}

      {desempenhoOpen && <DesempenhoGump />}
      {perguntaAtaque && (
        <ConfirmarAtaque
          nome={perguntaAtaque.nome}
          onCancelar={() => setPerguntaAtaque(null)}
          onConfirmar={() => {
            inocentesConfirmados.current.add(perguntaAtaque.id);
            const fazer = perguntaAtaque.fazer;
            setPerguntaAtaque(null);
            fazer();
          }}
        />
      )}

      <CantoDireito>
        <ChefeBarra estado={world.chefe} onClick={abrirChefe} />
        <EventoSelo
          ref={eventoSeloRef}
          estado={world.evento}
          aberto={eventoOpen}
          proximo={proximoEvento}
          onClick={toggleEvento}
        />
      </CantoDireito>

      {/* Os canvases do minimapa e do paperdoll ficam sempre montados: o motor
          desenha neles direto, e desmontá-los junto com a janela deixaria a
          referência nula depois que o mundo já subiu. O paperdoll da barra
          superior fica no botão do perfil. */}
      <div hidden={!profileOpen}>
        <GumpWindow
          title={nomeMarcado}
          anchor={{ left: 14, top: 58 }}
          className="win--profile pf"
          shown={profileOpen}
          onClose={() => setProfileOpen(false)}
        >
          <ProfileGump
            active={profileOpen}
            marca={marca}
            vipAte={world.vip?.ate ?? 0}
            tick={packTick}
            ganho={world.ganhoDoPerfil}
            canvas={<canvas ref={world.profileDollRef} className="paperdoll" width={120} height={156} aria-hidden="true" />}
            onChanged={text => world.say(text, 'system')}
          />
        </GumpWindow>
      </div>

      <div hidden={!inventoryOpen} ref={packWrapRef}>
        <GumpWindow
          title={t('mochila.inventario')}
          anchor={apostaAberta && packSpot ? packSpot : besidePlayerPack(world.canvasRef.current, world.playerScreen())}
          placeOnShow={!apostaAberta}
          seguirAncora={apostaAberta}
          className="win--inventory"
          shown={inventoryOpen}
          comeSlots
          headLead={<img className="gump__bag" src="/sprites/itens/hud/bag.png" alt="" width={22} height={20} draggable={false} />}
          onClose={() => {
            // O banco abre a mochila por cima na pilha do Esc. Fechar só ela
            // faz o efeito reabri-la, e o banco nunca recebe a tecla.
            if (mochilaPeloBanco.current) fecharBanco('close');
            else setPackOpen(false);
          }}
        >
          <InventoryGump
            active={inventoryOpen}
            tick={packTick}
            boneco={<canvas ref={world.inventoryDollRef} className="doll__cv" width={80} height={156} aria-hidden="true" />}
            onChanged={text => {
              world.say(text, 'system');
              setPackTick(n => n + 1);
            }}
            onMount={defId => { if (!dead) world.setMount(defId); }}
            onCloth={defId => { if (!dead) world.setCloth(defId); }}
            onWeapon={defId => { if (!dead) world.setMainHand(defId); }}
            onShield={defId => { if (!dead) world.setOffHand(defId); }}
            dead={dead}
            onCorpseDrop={(id, itemId, qty) => {
              void world.takeCorpse(id, itemId, qty).then(() => setPackTick(n => n + 1));
            }}
            onWallet={(gold, silver) => setWallet({ gold, silver })}
            onBankDeposit={banco ? (item, qty) => {
              if (item.equippedSlot) return;
              void api.guardarBanco(banco.npcId, { itemId: item.id, qty })
                .then(move => {
                  setWallet(carteiraDoPack(move.pack));
                  setPackTick(n => n + 1);
                })
                .catch(err => {
                  world.say(err instanceof ApiError ? err.message : t('comum.recusouPedido'), 'warn');
                });
            } : undefined}
            onVender={() => abrirJanela('vender')}
            onGuardaRoupa={() => setGuardaRoupaOpen(true)}
            onOffer={world.deal ? world.offerItem : undefined}
            offeredIds={world.deal?.mine.items.map(i => i.id) ?? []}
          />
        </GumpWindow>
      </div>

      {(shop || compraOpen) && (
        <GumpWindow
          title={shop ? t('compra.tituloNpc', { nome: shop.nome }) : t('compra.titulo', { cidade: world.sala.mapaNome || natal })}
          className="win--compra"
          corpoClasse="cc-win"
          anchor={{}}
          center
          comeSlots
          onClose={() => { if (shop) fecharLoja('close'); setCompraOpen(false); }}
        >
          <CompraCidadeGump
            active
            tick={packTick}
            vendedorInicial={shop?.npcId ?? null}
            onResultado={({ evento, total }) => {
              if (shop) npcFalaRef.current(shop.remoteId, shop.nome, shop.papel, evento, total);
              if (evento === 'compra') setPackTick(n => n + 1);
            }}
          />
        </GumpWindow>
      )}

      {venderOpen && (
        <GumpWindow
          title={cacando || dead ? t('venda.titulo') : t('venda.tituloCidade', { cidade: world.sala.mapaNome || natal })}
          className="win--vender"
          corpoClasse="vd-corpo"
          anchor={{}}
          center
          comeSlots
          onClose={() => setVenderOpen(false)}
        >
          <VenderGump
            active={venderOpen}
            tick={packTick}
            cidade={world.sala.mapaNome}
            cacando={cacando}
            lugarCacada={ordem ? t(`cacada.${ordem.huntId}.nome`) : ''}
            natal={natal}
            dead={dead}
            onPack={pack => {
              setWallet(carteiraDoPack(pack));
              setPackTick(n => n + 1);
            }}
            onDiario={(texto, tom) => world.say(texto, tom)}
            onVoltar={voltarDaCacada}
          />
        </GumpWindow>
      )}

      {corretor && (
        <GumpWindow
          title={corretor.nome}
          className="win--shop win--house"
          anchor={corretorSpot}
          comeSlots
          onClose={() => fecharCorretor('close')}
        >
          <HouseGump
            npcId={corretor.npcId}
            active
            onAnuncio={({ lugar }) => {
              sayKeyRef.current('casa.diario.anuncio', {
                nome: corretor.nome, lugar, fala: corretor.fala
              });
            }}
            onIrParaCasa={minha => {
              const d = destinoDaCasa(minha);
              setDestinoCasa(d);
              fecharCorretor('close');
              if (!world.portal) world.usarViagem(d);
            }}
            onDevolveu={() => {
              setDestinoCasa(null);
              setCasasVersao(v => v + 1);
              sayKeyRef.current('casa.diario.devolveu', { nome: corretor.nome });
            }}
            onComprou={({ n, lugar, casa, minha }) => {
              setDestinoCasa(destinoDaCasa(minha));
              setCasasVersao(v => v + 1);
              const fala = falaDoNpc(corretor.papel, 'compra');
              falarNpcRef.current(corretor.remoteId, fala);
              sayKeyRef.current('casa.diario.comprou', {
                nome: corretor.nome, n, lugar, casa, fala
              });
            }}
          />
        </GumpWindow>
      )}

      {naMinhaCasa && (
        <CasaBarra nome={nomeAqui} papel={papelAqui} casa={casaItens} janela={casaJanela}
          colocando={colocando && !colocando.movendo ? vagaDoItem(colocando.defId) : colocando ? 'preso' : null}
          onColocar={() => { void recarregarCasa(); setCasaJanela(j => (j === 'colocar' ? null : 'colocar')); }}
          onGerir={() => {
            void recarregarCasa();
            if (papelAqui === 'dono') void api.minhaCasa().then(setMinhaAcesso).catch(() => {});
            setCasaJanela(j => (j === 'gerir' ? null : 'gerir'));
          }} />
      )}
      {naMinhaCasa && podeMexer && colocando && (
        <FaixaColocacao defId={colocando.defId} nome={colocando.nome} movendo={colocando.movendo} casa={casaItens}
          podeGirar={colocacaoGira()} podeContinuar={continuarColocando && colocando.continua}
          onSubir={() => mudarAlturaColocacao(1)} onDescer={() => mudarAlturaColocacao(-1)}
          onGirar={girarColocacao} onCancelar={() => pararColocacao(true)} />
      )}
      {naMinhaCasa && podeMexer && casaJanela === 'colocar' && colocando && !colocando.movendo && <ColocarMinimizado />}
      {naMinhaCasa && podeMexer && casaJanela === 'colocar' && !colocando && (
        <GumpWindow title={t('casa.colocar.titulo')} className="win--casa-colocar" anchor={{ left: 24, top: 150 }} comeSlots
          onClose={() => setCasaJanela(null)}>
          <ColocarGump casa={casaItens} mochila={casaMochila} continuar={continuarColocando} onContinuar={setContinuarColocando}
            onBauGratis={() => comecarColocacao({ bau: true })}
            onItem={item => comecarColocacao({ bau: false, item })} />
        </GumpWindow>
      )}
      {naMinhaCasa && casaJanela === 'gerir' && !colocando && (
        <GumpWindow title={t('casa.gerir.titulo')} className="win--casa-gerir" anchor={{ left: 24, top: 150 }} comeSlots
          onClose={() => setCasaJanela(null)}>
          <GerirGump casa={casaItens} busy={casaOcupada} minha={papelAqui === 'dono' ? minhaAcesso : null} nome={nomeAqui}
            onSoltar={id => void agirCasa(() => api.soltarDaCasa(hid, id))}
            onRecolherBau={id => { setBauAberto(b => (b === id ? null : b)); void agirCasa(() => api.recolherBauDaCasa(hid, id)); }}
            onAbrirBau={id => setBauAberto(id)}
            onMostrar={(x, y, z) => { if (mapaDasCasasAgora) destacarNaCasa(mapaDasCasasAgora, x, y, z); }}
            onMover={moverPeca}
            onPapel={(nome: string, papel: PapelDaLista) => void mudarAcesso(() => api.convidar(nome, papel))}
            onRemover={nome => void mudarAcesso(() => api.desconvidar(nome))}
            onAberta={aberta => void mudarAcesso(() => api.casaAberta(aberta))}
            onRenomear={nome => void mudarAcesso(() => api.nomeDaCasa(nome)).then(() => void recarregarCasa())} />
        </GumpWindow>
      )}
      {naMinhaCasa && bauDaJanela && casaItens && (
        <GumpWindow title={nomeDoBau(bauDaJanela, casaItens.baus.indexOf(bauDaJanela))} className="win--casa-bau"
          anchor={{ left: 24, top: 120 }} center comeSlots onClose={() => setBauAberto(null)}>
          <BauGump bau={bauDaJanela} vagas={bauDaJanela.vagas ?? casaItens.vagasPorBau} mochila={casaMochila} busy={casaOcupada}
            podeConfig={podeMexer} quase={casaItens.quase}
            onGuardar={(item, qty) => void agirCasa(() => api.guardarNoBau(hid, bauDaJanela.id, { itemId: item.id, qty }), false)}
            onTirar={(id, qty) => void agirCasa(() => api.tirarDoBau(hid, bauDaJanela.id, { id, qty }), false)}
            onConfig={cfg => void agirCasa(() => api.configBauDaCasa(hid, bauDaJanela.id, cfg), false)} />
        </GumpWindow>
      )}
      {casaMenu && pecaNoMenu && casaItens && (() => {
        const peca = pecaNoMenu;
        const regra = peca.tipo === 'oficio' ? casaRegras.find(x => x.oficio === peca.oficio.oficio) : undefined;
        const alvo = peca.tipo === 'bau' ? peca.bau : peca.tipo === 'oficio' ? peca.oficio : peca.preso;
        return (
          <MenuDaPeca x={casaMenu.x} y={casaMenu.y} peca={peca} casa={casaItens} podeMexer={podeMexer} busy={casaOcupada}
            bonus={regra ? resumoBonus(regra) : undefined}
            onFechar={() => setCasaMenu(null)}
            onAbrir={() => { if (peca.tipo === 'bau') setBauAberto(peca.bau.id); setCasaMenu(null); }}
            onUsar={() => { if (peca.tipo === 'oficio') usarOficio(peca.oficio.oficio, alvo.x, alvo.y, casaMenu.x, casaMenu.y); }}
            onSentar={() => sentarNa(alvo.x, alvo.y)}
            onMover={() => moverPeca({ tipo: peca.tipo === 'bau' ? 'bau' : 'preso', id: alvo.id })}
            onGirar={() => ajustarPeca(peca, 0, 1)}
            onAltura={d => ajustarPeca(peca, d, 0)}
            onSoltar={() => {
              setCasaMenu(null);
              if (peca.tipo === 'bau') { setBauAberto(null); void agirCasa(() => api.recolherBauDaCasa(hid, peca.bau.id)); }
              else void agirCasa(() => api.soltarDaCasa(hid, alvo.id));
            }} />
        );
      })()}
      {placa && performance.now() < placa.ate && (
        <div className="casa-placa-rotulo" style={{ left: placa.x, top: placa.y - 46 }} aria-live="polite">
          <b>{nomeDaCasa(placa.dados?.nome ?? placa.p.nome, placa.dados?.dono ?? placa.p.dono)}</b>
          <span>{t('casa.placa.dono')}: {placa.dados?.dono ?? placa.p.dono ?? t('casa.placa.semDono')}</span>
        </div>
      )}
      {placa && (
        <GumpWindow title={t('casa.placa.titulo')} className="win--casa-placa" anchor={{ left: Math.max(12, placa.x - 140), top: Math.max(80, placa.y + 16) }}
          onClose={() => setPlaca(null)}>
          <PlacaGump nome={nomeDaCasa(placa.dados?.nome ?? placa.p.nome, placa.dados?.dono ?? placa.p.dono)}
            nomeProprio={placa.dados?.nome ?? placa.p.nome} dono={placa.dados?.dono ?? placa.p.dono}
            modelo={placa.dados?.modelo ?? ''} aberta={placa.dados?.aberta ?? placa.p.aberta} papel={placa.dados?.papel ?? placa.p.papel}
            busy={casaOcupada}
            onGerenciar={casaAquiId === placa.p.casaId && (papelAqui === 'dono' || papelAqui === 'codono') ? () => {
              setPlaca(null);
              void recarregarCasa();
              if (papelAqui === 'dono') void api.minhaCasa().then(setMinhaAcesso).catch(() => {});
              setCasaJanela('gerir');
            } : undefined}
            onRenomear={(placa.dados?.papel ?? placa.p.papel) === 'dono' ? nome => {
              void mudarAcesso(() => api.nomeDaCasa(nome)).then(() => {
                void api.placaDaCasa(placa.p.casaId).then(d => setPlaca(a => (a ? { ...a, dados: d } : a))).catch(() => {});
                void recarregarCasa();
              });
            } : undefined} />
        </GumpWindow>
      )}

      {banco && (
        <GumpWindow
          title={t('banco.titulo')}
          className="win--banco"
          anchor={bancoSpot}
          seguirAncora
          comeSlots
          onClose={() => fecharBanco('close')}
        >
          <BankGump
            npcId={banco.npcId}
            active
            tick={packTick}
            onPack={pack => {
              setWallet(carteiraDoPack(pack));
              setPackTick(n => n + 1);
            }}
            onErro={text => world.say(text, 'warn')}
          />
        </GumpWindow>
      )}

      {world.corpses.map((corpo, i) => {
        const base = besideYou(world.canvasRef.current);
        return (
        <GumpWindow
          key={corpo.id}
          title={corpo.ownerName
            ? t('loot.corpoDe', { nome: corpo.ownerName })
            : corpo.mobDefId
              ? t('loot.corpoDe', { nome: nomeDoInimigo(corpo.mobDefId) })
              : t('loot.titulo')}
          className="win--loot"
          headLead={<span className="saque-crista" aria-hidden="true" />}
          anchor={{ left: (base.left ?? 8) + i * 36, top: (base.top ?? 48) + i * 28 }}
          onClose={() => world.closeCorpse(corpo.id)}
        >
          <LootGump
            slots={corpo.slots}
            untilMs={corpo.untilMs}
            tick={packTick}
            onClose={() => world.closeCorpse(corpo.id)}
            onSlotClick={(itemId, qty) => {
              void world.takeCorpse(corpo.id, itemId, qty).then(() => setPackTick(n => n + 1));
            }}
            onTakeAll={ids => {
              void world.takeCorpseAll(corpo.id, ids).then(() => setPackTick(n => n + 1));
            }}
            dragOut={{
              mime: DRAG_CORPSE,
              payload: (itemId, qty) => JSON.stringify({
                id: corpo.id,
                itemId,
                ...(qty != null ? { qty } : {})
              })
            }}
          />
        </GumpWindow>
        );
      })}

      <div hidden={!minimapaVisivel}>
        <GumpWindow
          title={t('mundo.mapa')}
          bare
          hud
          className="win--minimap"
          anchor={anchorOf('mapa')}
          snapAnchor
          shown={minimapaVisivel}
          fechaNoEsc={false}
          onClose={() => { if (compacto) setMinimapaCompacto(false); else close('mapa'); }}
        >
          <div className="minimap-gump">
            <canvas ref={world.minimapRef} className={`minimap${dead ? ' minimap--ghost' : ''}`} width={200} height={200} aria-hidden="true" />
            <img
              src="/sprites/hud/gump_minimap.png"
              alt=""
              className="minimap-gump__frame"
              draggable={false}
              aria-hidden="true"
            />
          </div>
          <p className="coord">
            {world.status?.coord ?? '-'}
            {world.status && (
              <>
                <span className="coord__sep" aria-hidden="true"> · </span>
                {world.status.protegida
                  ? t('mundo.canalProtegido', { n: world.status.canal + 1 })
                  : t('mundo.canalCurto', { n: world.status.canal })}
              </>
            )}
          </p>
          {/* O nome do lugar, na segunda linha do radar (techspec-hud-v3 §18), e a hora de Britannia, discreta
              (techspec-dia-e-noite §05). */}
          <p className="coord coord--lugar">
            {world.sala.mapaNome && <span>{world.sala.mapaNome}</span>}
            <HoraDoMundo />
          </p>
        </GumpWindow>
      </div>

      {/* As placas do grupo (techspec-grupo-placas): painel solto, separado da sua placa de vida. */}
      {world.party && (
        <PainelGrupo
          key={world.sala?.mapaId ?? ''}
          party={world.party}
          youName={playerName}
          alvoSelecionado={world.status?.alvoSelecionado ?? null}
          onMarcar={marcarMembro}
          onLeave={world.leaveParty}
          onKick={world.kickPartyMember}
          retratoDe={world.retratoDe}
          idDoJogador={world.idDoJogador}
        />
      )}

      {open.has('ordens') && (
        <GumpWindow title={t('mundo.ordens')} anchor={anchorOf('ordens')} onClose={() => close('ordens')}>
          <div className="orders">
            {ORDERS.map(order => {
              const cacar = order.id === 'cacar';
              return (
                <button
                  key={order.id}
                  type="button"
                  className="order"
                  disabled={!cacar}
                  onClick={cacar ? () => abrirJanela('cacar') : undefined}
                >
                  <span className="order__name">{t(order.nome)}</span>
                  {!cacar && <span className="pick__tag">{t('comum.emBreve')}</span>}
                  <span className="order__meta">{t(order.detalhe)}</span>
                </button>
              );
            })}
          </div>
        </GumpWindow>
      )}

      {coletaVivo && (
        <ColetaGump
          anchor={{ left: 14, top: 70 }}
          vivo={coletaVivo}
          estado={coletaApi.estado}
          minimizado={coletaMin}
          travadoEm={world.coletaTravadoEm}
          cancelando={coletaCancelando}
          onMinimizar={setColetaMin}
          onCancelar={() => void cancelarColeta()}
        />
      )}

      {ordem && !huntOpen && !coletaVivo && (
        <PilulaCacada
          ordem={ordem}
          manual={world.huntManual}
          onAbrir={() => abrirJanela('cacar')}
          onOrdem={setOrdem}
          onModo={world.setHuntManual}
          onAviso={texto => world.say(texto, 'warn')}
        />
      )}

      {huntOpen && (
        <HuntGump
          dead={dead}
          fadiga={world.status?.fadiga}
          fadigaMax={world.status?.fadigaMax}
          onModo={world.setHuntManual}
          onOrdem={setOrdem}
          onVerVip={() => { setLojaAba('vip'); abrirJanela('loja'); }}
          onClose={() => setHuntOpen(false)}
          onMinimize={() => setHuntOpen(false)}
        />
      )}

      {eventoOpen && (
        <EventoGump
          active={eventoOpen}
          anchor={eventoSpot}
          onClose={() => { setEventoOpen(false); lerPremiosEvento(); }}
          chefeBarra={world.chefe}
          pentaBarra={world.penta}
          abrirTipo={eventoTipo}
        />
      )}

      <div hidden={!lojaOpen}>
        <GumpWindow
          title={t('loja.tituloReino')}
          anchor={{ left: 80, top: 70 }}
          center
          snapAnchor
          className="lj win--loja"
          posicao="loja"
          shown={lojaOpen}
          onClose={() => setLojaOpen(false)}
        >
          <LojaGump
            active={lojaOpen}
            abaInicial={lojaAba}
            nome={playerName}
            shardId={character?.shardId ?? ''}
            personagemId={character?.id ?? ''}
            pele={character?.skin ?? ''}
            peleHue={character?.skinHue ?? 0}
            morto={dead}
            onOuro={setLojaOuro}
            onMontar={defId => { if (!dead) world.setMount(defId); }}
            onChanged={text => {
              world.say(text, 'system');
              setPackTick(n => n + 1);
            }}
          />
        </GumpWindow>
      </div>

      <div hidden={!marketOpen}>
        <GumpWindow
          title={t('hud.menu.leilao')}
          anchor={{ left: 0, top: 0 }}
          center
          snapAnchor
          className="lei win--mercado"
          posicao="leilao"
          shown={marketOpen}
          comeSlots
          onClose={() => setMarketOpen(false)}
        >
          <LeilaoGump
            active={marketOpen}
            tick={packTick}
            onChanged={text => {
              world.say(text, 'system');
              setPackTick(n => n + 1);
            }}
          />
        </GumpWindow>
      </div>

      {([
        { oficio: 'ferraria', aberta: ferreiroOpen, fechar: () => setFerreiroOpen(false), titulo: 'ferraria.titulo', top: 84 },
        { oficio: 'arcos', aberta: arqueiroOpen, fechar: () => setArqueiroOpen(false), titulo: 'arcos.titulo', top: 96 },
        { oficio: 'alfaiataria', aberta: alfaiateOpen, fechar: () => setAlfaiateOpen(false), titulo: 'alfaiataria.titulo', top: 90 }
      ] as const).map(w => {
        // Minimizada na pílula enquanto o craft deste ofício anda; volta sozinha com o resultado.
        const minimizada = craftMin && craft?.oficio === w.oficio;
        return (
          <div key={w.oficio} hidden={!w.aberta || minimizada}>
            <GumpWindow
              title={t(w.titulo)}
              anchor={{ left: 320, top: w.top }}
              className="p-of"
              comeSlots
              shown={w.aberta && !minimizada}
              snapAnchor
              onClose={w.fechar}
            >
              <OficinaGump
                oficio={w.oficio}
                active={w.aberta}
                tick={packTick}
                onVerMochila={() => setPackOpen(true)}
                onResultado={ev => {
                  setPackTick(n => n + 1);
                  if (ev.evento === 'fez')
                    world.sayKey(ev.excepcional ? 'oficina.fezExcepcional' : 'oficina.fez', { item: ev.nome }, 'system');
                  else
                    world.say(ev.texto, 'system');
                }}
              />
            </GumpWindow>
          </div>
        );
      })}

      {craft && (craftMin || !janelaDoCraftAberta) && (
        <PilulaIdle
          className="craft-min"
          arte={<ItemIcon id={craft.defId} label="" size={22} />}
          estado={craft.fase === 'indo'
            ? t('oficio.pilula.indo', { nome: craft.nome })
            : t('oficio.pilula.fazendo', { nome: craft.nome, n: craft.feitas + 1, total: craft.total })}
          relogio={tempoDesde(craft.inicio, agoraCraft)}
          abrirDica={t('oficio.pilula.abrir')}
          sairDica={t('oficio.pilula.parar')}
          onAbrir={() => {
            // Fechou a janela no meio do craft: a pílula a reabre, com a barra de progresso.
            if (craft.oficio === 'ferraria') setFerreiroOpen(true);
            else if (craft.oficio === 'arcos') setArqueiroOpen(true);
            else setAlfaiateOpen(true);
            setCraftMin(false);
          }}
          onSair={pararCraft}
        />
      )}

      <div hidden={!guildOpen}>
        <GumpWindow
          title={t('guilda.titulo')}
          anchor={{ left: 14, top: 62 }}
          className="p-gld"
          corpoClasse="p-gld__corpo"
          shown={guildOpen}
          snapAnchor
          onClose={() => setGuildOpen(false)}
        >
          <GuildGump
            active={guildOpen}
            youName={playerName}
            podeGrupo={!world.party || world.party.canInvite}
            onChanged={refreshHouse}
            onMensagem={abrirConversa}
            onConvidarGrupo={nome => world.invitePartyMember(nome)}
          />
        </GumpWindow>
      </div>

      <div hidden={!friendsOpen}>
        <AmigosGump
          shown={friendsOpen}
          amigos={amigos}
          erroLista={erroAmigos}
          canInviteGuild={!!house?.canInvite}
          podeGrupo={!world.party || world.party.canInvite}
          unread={world.unreadTells}
          onClose={() => setFriendsOpen(false)}
          onReload={recarregarAmigos}
          onConversar={nome => abrirConversaChat(nome, true)}
          onParty={nome => world.invitePartyMember(nome)}
          onGuild={nome => { void api.inviteGuild(nome).then(() => world.say(t('guilda.convidou', { nome }), 'system')).catch(err => world.say(err instanceof ApiError ? err.message : t('comum.recusouPedido'), 'warn')); }}
        />
      </div>

      {dpsOpen && (
        <GumpWindow
          title={t('dps.titulo')}
          anchor={DPS_ANCHOR}
          className="win--dps"
          shown
          onClose={() => setDpsOpen(false)}
        >
          <DpsGump
            key={world.youId}
            listenStrike={world.listenStrike}
            listenStrikeCap={world.listenStrikeCap}
          />
        </GumpWindow>
      )}

      {ehStaff && (
      <>
      <div hidden={!gmOpen}>
        <GumpWindow
          title={t('gm.tituloLongo')}
          anchor={{ left: 190, top: 58 }}
          className="win--gm"
          shown={gmOpen}
          onClose={() => setGmOpen(false)}
        >
          <GmGump
            active={gmOpen}
            youName={playerName}
            role={account?.role}
            shard={character?.shardId}
            canal={world.status?.canal}
            oculto={gmOculto}
            onOculto={setGmOculto}
            onPickTile={hint => world.pickTile(hint)}
            onCancelPick={() => world.cancelTilePick()}
            onTeleportedSelf={(x, y) => world.teleportSelf(x, y)}
            onChangeCity={id => net ? Promise.resolve() : world.trocarMapa(id)}
            targetMobId={targetMobId}
            tileX={world.status?.tileX}
            tileY={world.status?.tileY}
            onSpawned={(mob, hits) => {
              if (!net) world.spawnLocalMob({
                id: mob.shortId,
                name: mob.name,
                x: mob.x,
                y: mob.y,
                defId: mob.defId,
                hits,
                hitsMax: hits,
                range: mob.range
              });
            }}
            onRemoved={id => { if (!net) world.removeLocalMob(id); }}
            skillsTick={gmSkillsTick}
            packTick={packTick}
            onPackChanged={() => setPackTick(n => n + 1)}
            onEditarSkills={setGmSkillsAlvo}
          />
        </GumpWindow>
      </div>
      {gmSkillsAlvo && (
        <GumpWindow
          title={t('gm.skills.titulo', { nome: gmSkillsAlvo.name })}
          anchor={{ left: 790, top: 58 }}
          className="win--skills"
          shown
          comeSlots
          onClose={() => {
            if (gmSkillsDirty.current && !window.confirm(t('gm.skills.descartar'))) return;
            gmSkillsDirty.current = false;
            setGmSkillsAlvo(null);
          }}
        >
          <GmSkillsGump
            characterId={gmSkillsAlvo.id}
            name={gmSkillsAlvo.name}
            onDirty={dirty => { gmSkillsDirty.current = dirty; }}
            onAplicou={() => setGmSkillsTick(n => n + 1)}
            onClose={() => {
              gmSkillsDirty.current = false;
              setGmSkillsAlvo(null);
            }}
          />
        </GumpWindow>
      )}
      </>
      )}

      {tellsVisiveis.map((tell, i) => (
        <GumpWindow
          key={tell.key}
          title={tell.label}
          anchor={{ right: 14 + i * 28, top: 200 + i * 32 }}
          onClose={() => closeTell(tell.label)}
        >
          <TellPanel
            name={tell.label}
            lines={world.tells[tell.key] ?? []}
            notice={tell.key === openTells[openTells.length - 1]?.key ? world.tellNotice : null}
            canSend
            onSend={text => world.tellToServer(tell.label, text)}
          />
        </GumpWindow>
      ))}

      {tip && !menu && !dummyMenu && <PlayerTip name={tip.name} x={tip.x} y={tip.y} />}

      {menu && (
        <PlayerMenu
          name={menu.name}
          cargo={menu.cargo}
          x={menu.x}
          y={menu.y}
          notoriety={menu.notoriety}
          rel={menu.rel}
          dist={menu.dist}
          alreadyFriend={friendNames.has(menu.name.trim().toLowerCase())}
          noGrupo={menu.rel === 3 || !!world.party?.members.some(m => m.name.trim().toLowerCase() === menu.name.trim().toLowerCase())}
          canKick={!!world.party?.canKick}
          onKick={() => {
            world.kickPartyMember(menu.name);
            dismissMenu();
          }}
          onRemoveFriend={() => void removerAmigoPeloNome(menu.name)}
          canInvite={!!house?.canInvite}
          targetHasGuild={!!menu.guildTag}
          onTell={() => abrirConversa(menu.name)}
          onInspect={() => {
            const name = menu.name;
            dismissMenu();
            void api.inspecionar(name)
              .then(setInspecao)
              .catch(err => world.say(err instanceof ApiError ? err.message : t('inspecao.erro'), 'warn'));
          }}
          onAdd={() => void addFriend(menu.name)}
          onTrade={() => {
            world.inviteTrade(menu.name);
            dismissMenu();
          }}
          onDuel={() => {
            setDueloAlvo(menu.name);
            dismissMenu();
          }}
          canParty={!world.party || world.party.canInvite}
          onParty={() => {
            world.invitePartyMember(menu.name);
            dismissMenu();
          }}
          onInvite={() => {
            const name = menu.name;
            dismissMenu();
            void api.inviteGuild(name)
              .then(() => world.say(t('guilda.convidou', { nome: name }), 'system'))
              .catch(err => world.say(err instanceof ApiError ? err.message : t('guilda.naoConvidou'), 'warn'));
          }}
          onReport={() => {
            setReportName(menu.name);
            dismissMenu();
          }}
          onClose={dismissMenu}
        />
      )}

      {dummyMenu && (
        <DummyMenu
          dummyId={dummyMenu.id}
          x={dummyMenu.x}
          y={dummyMenu.y}
          bonus={bonecoDaCasa && world.dummyEm(bonecoDaCasa.x, bonecoDaCasa.y) === dummyMenu.id ? bonusDoBoneco : undefined}
          onPick={(id, skill) => { void pickDummySkill(id, skill); }}
          onClose={dismissMenu}
        />
      )}

      {world.guildInvite && (
        <GuildInviteGump
          name={world.guildInvite.name}
          tag={world.guildInvite.tag}
          guildName={world.guildInvite.guildName}
          onAccept={() => {
            void api.acceptGuild()
              .then(() => refreshHouse(t('guilda.entrou')))
              .catch(err => world.say(err instanceof ApiError ? err.message : t('guilda.inviteGone'), 'warn'))
              .finally(() => world.clearGuildInvite());
          }}
          onRefuse={() => {
            void api.declineGuild().catch(() => {});
            world.clearGuildInvite();
          }}
        />
      )}

      {world.allianceInvite && (
        <AllianceInviteGump
          fromTag={world.allianceInvite.fromTag}
          fromName={world.allianceInvite.fromName}
          onAccept={() => {
            void api.acceptAlliance()
              .then(() => refreshHouse(t('guilda.aliancaAceita')))
              .catch(err => world.say(err instanceof ApiError ? err.message : t('guilda.propostaExpirou'), 'warn'))
              .finally(() => world.clearAllianceInvite());
          }}
          onRefuse={() => {
            void api.declineAlliance().catch(() => {});
            world.clearAllianceInvite();
          }}
        />
      )}

      {world.warInvite && (
        <WarInviteGump
          fromTag={world.warInvite.fromTag}
          fromName={world.warInvite.fromName}
          format={world.warInvite.format}
          onAccept={() => {
            void api.acceptWar()
              .then(() => refreshHouse(t('guilda.guerraAceita')))
              .catch(err => world.say(err instanceof ApiError ? err.message : t('guilda.declaracaoExpirou'), 'warn'))
              .finally(() => world.clearWarInvite());
          }}
          onRefuse={() => {
            void api.declineWar().catch(() => {});
            world.clearWarInvite();
          }}
        />
      )}

      {world.partyInvite && (
        <PartyInviteGump
          name={world.partyInvite}
          onAccept={() => world.respondParty(true)}
          onRefuse={() => world.respondParty(false)}
        />
      )}

      {world.dealInvite && (
        <TradeInviteGump
          name={world.dealInvite}
          onAccept={() => world.respondTrade(true)}
          onRefuse={() => world.respondTrade(false)}
        />
      )}

      {(['viajar', 'recursos'] as const).filter(id => fabAberto[id]).map(id => (
        <ViajarGump
          key={id}
          recursos={id === 'recursos'}
          anchor={ancoraAoLado(posFab, id)}
          mapaId={world.sala.mapaId || mapaId}
          destinos={destinosDoMenu}
          cacando={cacando}
          coleta={coletaVivo}
          coletaEstado={coletaApi.estado}
          // O idle entra minimizado (techspec-hud-v3 §18): a pílula diz o que está fazendo; clicar nela abre a janela.
          onColetaIniciada={() => { setColetaMin(true); void coletaApi.recarregar(); fecharFab(id); }}
          onColetaReabrir={() => { setColetaMin(false); fecharFab(id); }}
          onFechar={() => fecharFab(id)}
          onDestino={(d, protegida) => {
            if (coletando) void cancelarColeta(d.id);
            else if (!world.portal) world.usarViagem(d, protegida);
            fecharFab(id);
          }}
        />
      ))}
      {pop === 'lojas' && (
        <PopLojas
          x={xDoPop('lojas')}
          cidade={world.sala.mapaNome}
          cacando={cacando}
          ordem={ordem}
          natal={natal}
          esc
          onFechar={() => setPop(null)}
          onComprar={() => { setCompraOpen(true); setPop(null); }}
          onVender={() => abrirJanela('vender')}
          onVoltar={voltarDaCacada}
          onCacar={() => abrirJanela('cacar')}
        />
      )}
      {pop === 'oficios' && (
        <PopOficios
          x={xDoPop('oficios')}
          bonus={bonusDaCasa}
          cacando={cacando}
          ordem={ordem}
          natal={natal}
          esc
          onFechar={() => setPop(null)}
          onAbrir={id => abrirJanela(id)}
          onVoltar={voltarDaCacada}
          onCacar={() => abrirJanela('cacar')}
        />
      )}
      {pop === 'treinar' && (
        <PopTreinar
          x={xDoPop('treinar')}
          cacando={cacando}
          ordem={ordem}
          natal={natal}
          esc
          onFechar={() => setPop(null)}
          travado={naMinhaCasa && !bonecoDaCasa ? t('casa.oficio.semBoneco') : undefined}
          bonus={naMinhaCasa && bonecoDaCasa ? bonusDoBoneco ?? t('casa.oficio.bonecoSemBonus') : undefined}
          onEscolher={treinarNoManequim}
          onVoltar={voltarDaCacada}
          onCacar={() => abrirJanela('cacar')}
        />
      )}
      {pop === 'fadiga' && (
        <PopFadiga x={xDoPop('fadiga')} status={world.status} onFechar={() => setPop(null)} />
      )}
      {pop === 'mais' && (
        <PopMais
          x={xDoPop('mais')}
          modoCel={modo === 'cel'}
          compacto={compacto}
          minimapa={minimapaVisivel}
          ehStaff={ehStaff}
          online={online}
          teclaConfig={teclaDeAcao('config')}
          teclaGm={teclaDeAcao('gm')}
          suportePede={suportePede}
          correioNovas={correio.novas}
          indicar={indicarAtivo}
          onFechar={() => setPop(null)}
          onJanela={id => abrirJanela(id)}
          onGuia={() => { setPop(null); setGuiaRevendo(true); }}
          onMinimapa={() => { setMinimapaCompacto(v => !v); setPop(null); }}
        />
      )}
      {pop === 'cidade' && (
        <PopCidade
          x={xDoPop('cidade')}
          cidade={world.sala.mapaNome}
          cacando={cacando}
          onFechar={() => setPop(null)}
          onPop={id => setPop(id)}
          onBanco={abrirBanco}
          onMercado={() => abrirJanela('mercado')}
        />
      )}
      {pop === 'social' && (
        <PopSocial
          x={xDoPop('social')}
          on={amigosOn}
          n={amigos.length}
          naoLidas={naoLidasAmigos}
          onFechar={() => setPop(null)}
          onGuilda={() => abrirJanela('guilda')}
          onAmigos={() => abrirJanela('amigos')}
        />
      )}
      {guiaAberto && guiaLiberado && character && (
        <GuiaBoasVindas
          nome={character.name}
          modo={modo}
          escFecha={!tutorial}
          onFechar={fecharGuia}
          onCacar={() => { fecharGuia(); abrirJanela('cacar'); }}
        />
      )}
      <ChatHud
        journal={world.journal}
        combat={world.combat}
        global={world.global}
        trade={world.trade}
        guild={world.guild}
        alliance={world.alliance}
        hasGuild={!!house}
        hasAlliance={!!house?.alliance}
        net={world.net}
        local={world.local}
        onSay={world.sayToServer}
        focoSeq={focoFala}
        aba={abaChat}
        onAba={a => { setConversaChat(null); setAbaChat(a); }}
        naoLidas={naoLidasChat}
        total={totalChat + conversasChat.reduce((n, c) => n + (world.unreadTells[c.key] ?? 0), 0)}
        conversas={conversasChat.map(c => ({
          key: c.key,
          nome: c.label,
          // quem saiu da lista de amigos continua com a aba; o servidor avisa se a pessoa estiver offline
          online: amigos.find(a => tellKey(a.name) === c.key)?.online ?? true,
          naoLidas: world.unreadTells[c.key] ?? 0,
          linhas: world.tells[c.key] ?? []
        }))}
        conversa={conversaChat}
        onConversa={setConversaChat}
        onFecharConversa={fecharConversaChat}
        onTell={world.tellToServer}
        tellNotice={world.tellNotice}
        chatAberto={chatAberto}
        onAbrir={alternarChat}
        onFechar={() => setChatAberto(false)}
        min={chatMin}
        onMin={mudarChatMin}
      />

      {(world.pentaLugar || world.pentaCanal) && !portalAberto && (
        <PentaGump
          lugar={world.pentaLugar}
          canal={world.pentaCanal}
          estado={world.penta}
          altar={world.pentaAltar}
          eu={character?.name ?? ''}
          tick={packTick}
          onForjar={world.pentaForjar}
          onEngastar={world.pentaEngastar}
          onRitual={world.pentaRitual}
          onCancelar={world.pentaCancelar}
        />
      )}

      {portalAberto && (
        <PortalGump
          destino={t(portalAberto.rotulo)}
          teleporte={!world.portal}
          onAccept={() => {
            if (world.portal) { playPortal(); world.confirmarPortal(); }
            else if (viagemMenu) {
              world.usarViagem(viagemMenu);
              setViagemMenu(null);
            }
          }}
          onRefuse={() => {
            if (world.portal) world.recusarPortal();
            setViagemMenu(null);
          }}
        />
      )}

      {world.duelo && (
        <DueloHud
          estado={world.duelo}
          onDesistir={world.desistirDuelo}
          onSair={world.sairDuelo}
        />
      )}

      {world.dueloResultado && !world.duelo && (
        <DueloResultadoAviso estado={world.dueloResultado} onFechar={world.limparDueloResultado} />
      )}

      {world.dueloConvite && (
        <DueloConviteCard
          key={`${world.dueloConvite.de}|${world.dueloConvite.expiraEmMs}`}
          de={world.dueloConvite.de}
          modo={world.dueloConvite.modo}
          comAposta={world.dueloConvite.comAposta}
          expiraEmMs={world.dueloConvite.expiraEmMs}
          retratoDe={world.retratoDe}
          onAccept={() => world.responderDuelo(true)}
          onRefuse={() => world.responderDuelo(false)}
        />
      )}

      {world.dueloEnviado && !world.duelo && (
        <DueloEnviadoPilula
          key={`${world.dueloEnviado.para}|${world.dueloEnviado.expiraEmMs}`}
          para={world.dueloEnviado.para}
          modo={world.dueloEnviado.modo}
          comAposta={world.dueloEnviado.comAposta}
          expiraEmMs={world.dueloEnviado.expiraEmMs}
          onCancelar={world.cancelarDesafio}
        />
      )}

      {world.dueloVoltar && (
        <DueloConviteGump
          de={world.dueloVoltar.adversario}
          modo="sem_loot"
          texto={t('duelo.voltarTexto', { nome: world.dueloVoltar.adversario, placar: world.dueloVoltar.placar })}
          titulo={t('duelo.voltarArena')}
          aceitar={t('duelo.voltarArena')}
          recusar={t('duelo.desistir')}
          onAccept={() => world.voltarDuelo(true)}
          onRefuse={() => world.voltarDuelo(false)}
        />
      )}

      {dueloAlvo && (
        <DueloConfigGump
          nome={dueloAlvo}
          retratoDe={world.retratoDe}
          onClose={() => setDueloAlvo(null)}
          onEnviar={(modo, aposta) => {
            world.desafiar(dueloAlvo, modo, aposta);
            setDueloAlvo(null);
          }}
        />
      )}

      {world.deal && (
        <div ref={tradeWrapRef}>
        <GumpWindow
          title={world.deal.tipo === 'aposta'
            ? t('duelo.apostaTitulo', { modo: world.deal.modo === 'com_loot' ? t('duelo.comLoot') : t('duelo.semLoot') })
            : t('troca.titulo')}
          anchor={tradeSpot}
          snapAnchor={!apostaAberta}
          seguirAncora={apostaAberta}
          className="win--trade"
          onClose={world.cancelTrade}
        >
          <TradeGump
            state={world.deal}
            onOfferGold={world.offerGold}
            onTakeBack={world.takeBack}
            onReady={world.readyTrade}
            onCancel={world.cancelTrade}
          />
        </GumpWindow>
        </div>
      )}

      {settingsOpen && (
        <SettingsModal
          onClose={() => setSettingsOpen(false)}
          onTrocarPersonagem={back}
          nome={playerName}
          lugar={world.sala.mapaNome || world.status?.place || ''}
          shard={shardNome}
          abaInicial={retornoDiscord ? 'conta' : undefined}
          retornoDiscord={retornoDiscord}
        />
      )}

      {rankingsOpen && (
        <RankingsModal
          onClose={() => setRankingsOpen(false)}
        />
      )}

      {correioOpen && (
        <CorreioGump
          shown={correioOpen}
          abrir={correioAbrir}
          onClose={() => { setCorreioOpen(false); setCorreioAbrir(null); }}
          onResumo={(novas, pendentes) => setCorreio(c => ({ ...c, novas, pendentes }))}
          onRecebeu={texto => { world.say(texto, 'system'); setPackTick(n => n + 1); }}
        />
      )}

      {indicarOpen && <IndicarGump shown={indicarOpen} onClose={() => setIndicarOpen(false)} />}

      {suporteOpen && (
        <SuporteModal
          onClose={() => setSuporteOpen(false)}
          canvas={() => world.canvasRef.current}
          jogo={dadosParaSuporte}
          personagem={playerName}
          shard={shardNome}
          vip={!!world.vip && world.vip.ate > Date.now()}
          abaInicial={suportePede > 0 ? 'meus' : 'novo'}
          onMudou={lerResumoSuporte}
        />
      )}

      {guardaRoupaOpen && (
        <GuardaRoupaGump
          dead={dead}
          provador={world.provador}
          onVisual={cloth => { if (!dead) world.setCloth(cloth); }}
          onChanged={text => {
            world.say(text, 'system');
            setPackTick(n => n + 1);
          }}
          onClose={() => setGuardaRoupaOpen(false)}
        />
      )}

      {inspecao && (
        <GumpWindow title={inspecao.nome} anchor={INSPECAO_ANCHOR} className="win--inspecao" center onClose={() => setInspecao(null)}>
          <InspecaoGump dados={inspecao} bonecoDe={world.bonecoDe} />
        </GumpWindow>
      )}

      {reportName && (
        <ReportModal
          name={reportName}
          onCancel={() => setReportName(null)}
          onSent={() => {
            setReportName(null);
            world.say(t('denuncia.sent'), 'system');
          }}
        />
      )}

      {!dead && world.dummyTrain && (
        <GumpWindow
          title={t('manequim.treinando', { skill: nomeDaSkill(world.dummyTrain.skill) })}
          bare
          className="win--treino"
          hud
          anchor={TREINO_ANCHOR}
          snapAnchor
        >
          <DummyTrainGump
            title={t('manequim.treinando', { skill: nomeDaSkill(world.dummyTrain.skill) })}
            skills={world.dummyTrain.skills}
            onCancel={() => world.stopTrainDummy()}
          />
        </GumpWindow>
      )}

      {!dead && (world.corpoPendente || world.resgate.etapa !== 0) && (
        <ResgateCorpo
          corpo={world.corpoPendente}
          resgate={world.resgate}
          morreuCacando={!!cacadaPerdida}
          podeContinuar={!!cacadaPerdida && world.resgate.cacadas.includes(cacadaPerdida.huntId) && !cacando}
          abaixo={!!coletaVivo || (!!ordem && !huntOpen)}
          onResgatar={() => world.resgatarCorpo()}
          onCancelar={() => world.cancelarResgate()}
          onContinuar={continuarCacada}
          onFecharCorpo={() => world.fecharCorpoPendente()}
          onFecharResgate={() => world.fecharResgate()}
        />
      )}

      {dead && (
        <div className="ress-bar">
          {world.resOferta && (
            <ResOfertaAviso de={world.resOferta.de} ate={world.resOferta.ate} onResponder={world.responderRess} />
          )}
          {world.resBloqueio && (
            <ResBloqueioAviso
              aviso={world.resBloqueio}
              ocupado={world.resEstado.etapa !== 0}
              onCove={() => world.pedirRessCove()}
              onReviver={() => { world.fecharResBloqueio(); world.pedirRess(); }}
              onFechar={() => world.fecharResBloqueio()}
            />
          )}
          <button
            type="button"
            className="ress-bar__btn"
            disabled={world.resEstado.etapa !== 0}
            onClick={() => world.pedirRess()}
          >
            {t('ress.botao')}
          </button>
          {world.resEstado.etapa === 1 && (
            <p className="ress-bar__msg">{t('ress.viajando', { cidade: world.resEstado.cidade })}</p>
          )}
          {world.resEstado.etapa === 2 && (
            <p className="ress-bar__msg">{t('ress.caminhando')}</p>
          )}
        </div>
      )}

      <HintBar rotulo={world.status?.mundoNome} />

      <SkillBar
        status={world.status}
        vip={world.vip && world.vip.ate > Date.now()
          ? { ativo: true, prata: wallet.silver, semBanco: world.vip.semBanco, precos: world.vip.precos }
          : null}
        armed={world.ready}
        onWarn={text => world.say(text, 'warn')}
        castRefuse={world.castRefuse}
        consumeRefuse={world.consumeRefuse}
        consumePulse={world.consumePulse}
        castPulse={world.castPulse}
        recargaPulse={world.recargaPulse}
        swingPulse={world.swingPulse}
        mainHandDefId={world.mainHandDefId}
        consumiveis={world.consumiveis}
        war={world.war}
        retratoDoAlvo={world.retratoDoAlvo}
        adversarioDuelo={world.duelo && ['carregando', 'contagem', 'luta', 'ausente'].includes(world.duelo.estado) ? world.duelo.adversario : null}
        huntManual={world.huntManual}
        packOpen={packOpen || !!banco}
        onTogglePack={() => alternarJanela('mochila')}
        gearTick={packTick}
        cacando={cacando}
        viajarAberto={fabAberto.viajar}
        onViajar={() => alternarFab('viajar')}
        recursosAberto={fabAberto.recursos}
        onRecursos={() => alternarFab('recursos')}
        onPosicoesFab={setPosFab}
        amigosAberto={friendsOpen}
        amigosNaoLidas={naoLidasAmigos}
        onAmigos={() => alternarJanela('amigos')}
        correio={correio.novas > 0 && !(correioOpen && compacto) ? { novas: correio.novas, chegou: correio.chegou } : null}
        onCorreio={() => { setCorreioAbrir('nova'); abrirJanela('correio'); }}
        onCastSlot={(index, ignoraAlvo, idSlot) => {
          if (!world.net) {
            world.say(t('mundo.combateSoAoVivo'), 'note');
            return false;
          }
          const target = world.getTargetId();
          // O alvo é do seu grupo? (techspec-grupo-placas) Membro marcado recebe cura e buff, nunca ataque.
          const info = world.getTargetInfo();
          const membro = info && info.kind === 'player' && world.party
            ? world.party.members.find(m => m.name.trim().toLowerCase() === info.nome.trim().toLowerCase()) ?? null
            : null;
          if (index === SLOT_ARMA) {
            if (world.war) {
              world.attack(0);
              return true;
            }
            if (target == null) {
              world.say(t('mundo.selecioneAlvo'), 'note');
              return false;
            }
            if (membro) {
              world.say(t('grupo.naoAtaca', { nome: membro.name }), 'warn');
              return false;
            }
            return atacarConfirmando(target, () => world.attack(target));
          }
          // Self cast: com a tecla segurada (V), cura e buff vão sempre em você, mesmo com alvo marcado.
          if (idSlot && ehMagia(idSlot) && pressionada('autoAlvo') && aceitaAutoAlvo(MAGIAS[idSlot]) && world.youId) {
            world.cast(index, world.youId);
            return true;
          }
          // Cura e buff só vão em você ou num membro do grupo: com alvo de fora (ou sem alvo), caem em você sem
          // precisar do V. Membro morto não recebe e a cura não volta para você (techspec-grupo-placas).
          if (idSlot && ehMagia(idSlot) && aceitaAutoAlvo(MAGIAS[idSlot]) && world.youId) {
            if (!membro) {
              world.cast(index, world.youId);
              return true;
            }
            if (membro.state === 1) {
              world.say(t('grupo.alvoMorto', { nome: membro.name }), 'note');
              return false;
            }
            world.cast(index, target ?? world.youId);
            return true;
          }
          // Ressurreição: o servidor acha o fantasma (o marcado, ou o mais perto a 1 casa) (techspec-ressurreicao).
          if (idSlot && ehMagia(idSlot) && MAGIAS[idSlot].kind === 'resurrect') {
            world.cast(index, target ?? 0);
            return true;
          }
          if (target == null && !ignoraAlvo) {
            world.say(t('mundo.selecioneAlvo'), 'note');
            return false;
          }
          // Magia de ataque também conta como atacar (e o servidor já liga o War no alvo).
          const hostil = !!idSlot && ehMagia(idSlot) && ['damage', 'poison', 'paralyze', 'debuff', 'dispel'].includes(MAGIAS[idSlot].kind ?? '');
          // Membro do grupo nunca recebe magia de ataque: não sai e não gasta mana (o servidor também recusa).
          if (hostil && membro) {
            world.say(t('grupo.naoAtaca', { nome: membro.name }), 'warn');
            return false;
          }
          if (hostil && target != null)
            return atacarConfirmando(target, () => world.cast(index, target));
          world.cast(index, target ?? 0);
          return true;
        }}
      />
    </main>
    </ModoTelaContext.Provider>
  );
}
